import { jsx as r, jsxs as c, Fragment as re } from "react/jsx-runtime";
import * as ce from "@radix-ui/react-popover";
import * as G from "react";
import U, { memo as $t, forwardRef as dt, useState as T, cloneElement as pt, createContext as Bt, useEffect as oe, useContext as Yt, useMemo as ht, useRef as de, createElement as ot } from "react";
import { useWidget as j, useConfig as b, useSessions as $, useMessages as E, useWidgetRouter as A, useDocumentDir as ve, useWidgetTrigger as K, useModes as mt, useCsat as gt, useUploadFiles as Ut, useIsAwaitingBotReply as wt, useContact as qt, WidgetProvider as Xt, WidgetTriggerProvider as Vt } from "@opencx/widget-react-headless";
import { clsx as Gt } from "clsx";
import { twMerge as Kt } from "tailwind-merge";
import { motion as J, AnimatePresence as _ } from "framer-motion";
import { Slot as Qt } from "@radix-ui/react-slot";
import { cva as Zt } from "class-variance-authority";
import { X as Jt, CircleDashedIcon as er, XIcon as xe, SquareXIcon as tr, SquareCheckBigIcon as rr, SquareCheckIcon as or, ShrinkIcon as nr, Minimize2Icon as sr, MinimizeIcon as ar, Maximize2Icon as ir, MaximizeIcon as lr, ExpandIcon as cr, CircleXIcon as dr, CircleCheckBigIcon as pr, CircleCheckIcon as ut, CheckCheckIcon as hr, CheckIcon as mr, ChevronLeftIcon as gr, LoaderIcon as wr, ArrowUpIcon as ft, PaperclipIcon as ur, ImageIcon as fr, CircleDashed as vr, AlertCircle as xr, Loader2 as br, FileAudio2Icon as yr, FileVideo2Icon as kr, FileIcon as Cr, UserRoundIcon as zr, ChevronRightIcon as Nr, SendHorizontal as Sr, ChevronDownIcon as _r } from "lucide-react";
import vt from "remark-gfm";
import Ir from "react-markdown";
import xt from "rehype-raw";
import { isExhaustive as D, isSupportedLanguage as Tr, getTranslation as Mr } from "@opencx/widget-core";
import * as Q from "@radix-ui/react-avatar";
import bt from "@uiw/react-iframe";
import * as ne from "@radix-ui/react-tooltip";
import nt from "tinycolor2";
import { useDropzone as Dr } from "react-dropzone";
import jr from "react-use/lib/useAsyncFn";
import { z as me } from "zod";
function g(e) {
  return { "data-component": e };
}
function p(...e) {
  return Kt(Gt(e));
}
const V = {
  x: 2,
  y: 2
}, L = $t(
  dt(
    ({ children: e, className: o, scale: t = 1.02, off: n = !1 }, s) => {
      const [i, a] = T(!1), [l, d] = T({ x: 0, y: 0 });
      if (n || /translate/.test(
        e.props.className || ""
      )) return e;
      const y = (w) => {
        var N, S;
        const { clientX: k, clientY: I } = w, f = w.currentTarget.getBoundingClientRect(), M = k - (f.left + f.width / 2), O = I - (f.top + f.height / 2), H = Math.max(
          -1,
          Math.min(1, M / (f.width / 2))
        ), W = Math.max(
          -1,
          Math.min(1, O / (f.height / 2))
        ), R = H * V.x, v = W * V.y;
        d({ x: R, y: v }), (S = (N = e.props).onMouseMove) == null || S.call(N, w);
      }, x = () => {
        var w, k;
        a(!0), (k = (w = e.props).onMouseEnter) == null || k.call(w);
      }, m = () => {
        var w, k;
        a(!1), d({ x: 0, y: 0 }), (k = (w = e.props).onMouseLeave) == null || k.call(w);
      }, z = {
        "--wobble-x": i ? `${l.x}px` : "0px",
        "--wobble-y": i ? `${l.y}px` : "0px",
        "--scale": 1 - (t - 1)
      };
      return pt(e, {
        ref: s,
        onMouseMove: y,
        onMouseEnter: x,
        onMouseLeave: m,
        style: {
          ...z,
          ...e.props.style
        },
        className: p(
          "translate-x-[var(--wobble-x)]",
          "translate-y-[var(--wobble-y)]",
          "hover:scale-[var(--scale)] active:hover:scale-[calc(var(--scale)-0.02)]",
          o,
          e.props.className,
          "transition-all ease-out"
        )
      });
    }
  )
);
L.displayName = "Wobble";
const Er = 10, Rr = (e, o, t) => ({
  initial: { opacity: 0, x: -e, ...o.initial },
  animate: { opacity: 1, x: 0, ...o.animate, transition: { delay: t } },
  exit: { opacity: 0, x: e, ...o.exit }
}), Pr = (e, o, t) => ({
  initial: { opacity: 0, x: e, ...o.initial },
  animate: { opacity: 1, x: 0, ...o.animate, transition: { delay: t } },
  exit: { opacity: 0, x: -e, ...o.exit }
}), Ar = (e, o, t) => ({
  initial: { opacity: 0, y: e, ...o.initial },
  animate: { opacity: 1, y: 0, ...o.animate, transition: { delay: t } },
  exit: { opacity: 0, y: -e, ...o.exit }
}), Fr = (e, o, t) => ({
  initial: { opacity: 0, y: -e, ...o.initial },
  animate: { opacity: 1, y: 0, ...o.animate, transition: { delay: t } },
  exit: { opacity: 0, y: e, ...o.exit }
}), Or = {
  right: Rr,
  left: Pr,
  up: Ar,
  down: Fr
}, u = dt(
  ({
    fadeIn: e = "down",
    distance: o = Er,
    children: t,
    snapExit: n = !1,
    overrides: s = {},
    delay: i = 0,
    ...a
  }, l) => {
    const d = e ? Or[e](o, s, i) : {};
    return n && d.exit && typeof d.exit == "object" && !Array.isArray(d.exit) && (d.exit.transition = { duration: 0 }), /* @__PURE__ */ r(J.div, { ref: l, ...a, ...d, children: t });
  }
);
u.displayName = "MotionDiv";
const Hr = Zt(
  p(
    "inline-flex shrink-0 items-center justify-center gap-2",
    "text-sm font-medium whitespace-nowrap",
    "ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
    "disabled:pointer-events-none disabled:opacity-50",
    "active:scale-95 hover:active:scale-95",
    "rounded-xl",
    "transition"
  ),
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground",
        destructive: "bg-destructive text-destructive-foreground",
        outline: "bg-background border",
        secondary: "bg-secondary text-secondary-foreground",
        ghost: "hover:bg-secondary",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "py-2 px-3.5 text-xs",
        /**
         * This size is useful for top level buttons that needs to sit nicely inside the iframe's border radius.
         * Having the minimum height higher than usual (the `default` variant) will make the border radius look just right.
         */
        lg: "min-h-12 px-4 rounded-[20px]",
        icon: "h-10 w-10",
        fit: "size-fit p-2",
        free: "p-2",
        selfless: "p-0"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), C = G.forwardRef(
  ({ className: e, variant: o = "default", size: t, asChild: n = !1, ...s }, i) => /* @__PURE__ */ r(L, { ref: i, children: /* @__PURE__ */ r(
    n ? Qt : "button",
    {
      ...g("ui_lib/btn"),
      "data-variant": o,
      className: p(Hr({ variant: o, size: t, className: e })),
      ...s
    }
  ) })
);
C.displayName = "Button";
const yt = Bt(null);
function Wr({ children: e }) {
  const [o, t] = T(!1), [n, s] = T(null), i = (l) => {
    s(l), t(!0);
  }, a = () => {
    t(!1), setTimeout(() => {
      s(null);
    }, 200);
  };
  return /* @__PURE__ */ c(
    yt.Provider,
    {
      value: { open: i, close: a, isOpen: o, content: n },
      children: [
        /* @__PURE__ */ r(Lr, {}),
        e
      ]
    }
  );
}
function pe() {
  const e = Yt(yt);
  return e || (console.error("useDialoger must be used within a DialogerProvider"), {
    open: () => {
    },
    close: () => {
    },
    isOpen: !1,
    content: null
  });
}
function Lr() {
  const { contentIframeRef: e } = j(), { isOpen: o, content: t, close: n } = pe();
  return oe(() => {
    var i, a;
    const s = (l) => {
      l.key === "Escape" && n();
    };
    return (a = (i = e == null ? void 0 : e.current) == null ? void 0 : i.contentWindow) == null || a.document.addEventListener(
      "keydown",
      s
    ), () => {
      var l, d;
      return (d = (l = e == null ? void 0 : e.current) == null ? void 0 : l.contentWindow) == null ? void 0 : d.document.removeEventListener(
        "keydown",
        s
      );
    };
  }, []), /* @__PURE__ */ r(_, { mode: "wait", children: o && t && /* @__PURE__ */ r(
    u,
    {
      overrides: {
        initial: { y: 0 },
        exit: { y: 0 }
      },
      className: "fixed inset-0 z-50 bg-black/60 backdrop-blur-sm",
      tabIndex: -1,
      onClick: n,
      children: t
    },
    "dialog-content"
  ) });
}
function kt({
  children: e,
  className: o,
  withClose: t = !1
}) {
  const { close: n } = pe();
  return /* @__PURE__ */ c(
    "div",
    {
      className: p(
        "fixed left-[50%] top-[50%] z-50 flex flex-col gap-4 w-full max-w-[61.8%] translate-x-[-50%] translate-y-[-50%] border bg-background p-4 rounded-3xl",
        o
      ),
      onClick: (s) => s.stopPropagation(),
      children: [
        e,
        t && /* @__PURE__ */ c(
          C,
          {
            size: "fit",
            className: "rounded-full absolute top-4 right-4",
            variant: "secondary",
            onClick: n,
            children: [
              /* @__PURE__ */ r(Jt, { className: "h-4 w-4" }),
              /* @__PURE__ */ r("span", { className: "sr-only", children: "Close" })
            ]
          }
        )
      ]
    }
  );
}
const Ct = ({
  className: e,
  ...o
}) => /* @__PURE__ */ r(
  "div",
  {
    className: p("flex flex-col gap-2 text-center pt-2", e),
    ...o
  }
);
Ct.displayName = "DialogerHeader";
const zt = ({
  className: e,
  ...o
}) => /* @__PURE__ */ r(
  "div",
  {
    className: p("flex flex-col gap-2 text-center", e),
    ...o
  }
);
zt.displayName = "DialogerBody";
const Nt = ({
  className: e,
  ...o
}) => /* @__PURE__ */ r("div", { className: p("flex flex-col gap-2", e), ...o });
Nt.displayName = "DialogerFooter";
const St = U.forwardRef(({ className: e, ...o }, t) => /* @__PURE__ */ r(
  "p",
  {
    ref: t,
    className: p(
      "text-lg font-semibold leading-none tracking-tight",
      e
    ),
    ...o
  }
));
St.displayName = "DialogerTitle";
const _t = U.forwardRef(({ className: e, ...o }, t) => /* @__PURE__ */ r(
  "p",
  {
    ref: t,
    className: p("text-sm text-muted-foreground", e),
    ...o
  }
));
_t.displayName = "DialogerDescription";
function It({
  children: e,
  trigger: o
}) {
  const { open: t } = pe();
  return pt(o, {
    onClick: () => t(e)
  });
}
function Tt({ attachment: e }) {
  const { name: o, size: t, type: n, url: s } = e, i = n.startsWith("image/"), a = n.startsWith("video/"), l = n.startsWith("audio/");
  return l ? /* @__PURE__ */ r(L, { children: /* @__PURE__ */ r("div", { className: "w-full shrink-0 overflow-hidden", children: /* @__PURE__ */ c("audio", { controls: !0, className: "w-full", children: [
    /* @__PURE__ */ r("source", { src: s, type: n }),
    "Your browser does not support the audio tag."
  ] }) }) }) : a ? /* @__PURE__ */ r(L, { children: /* @__PURE__ */ r("div", { className: "w-full border shrink-0 rounded-2xl overflow-hidden", children: /* @__PURE__ */ c("video", { controls: !0, children: [
    /* @__PURE__ */ r("source", { src: s, type: n }),
    "Your browser does not support the video tag."
  ] }) }) }) : !i && !a && !l ? /* @__PURE__ */ r(L, { children: /* @__PURE__ */ r("div", { className: "size-fit border shrink-0 rounded-2xl overflow-hidden", children: /* @__PURE__ */ c("div", { className: "flex items-end gap-2 p-2", children: [
    /* @__PURE__ */ r(
      "a",
      {
        href: s,
        target: "_blank",
        rel: "noopener noreferrer",
        className: p(
          "text-xs text-blue-500 line-clamp-2 underline hover:text-blue-600",
          "break-words [word-break:break-word]"
          // `[word-break:break-word]` is deprecated but works in the browser, while `break-words` which is `[overflow-wrap: break-word]` does not work
        ),
        children: o
      }
    ),
    /* @__PURE__ */ c("span", { className: "text-xs text-muted-foreground whitespace-nowrap", children: [
      (t / 1024).toFixed(2),
      " KB"
    ] })
  ] }) }) }) : /* @__PURE__ */ r(
    It,
    {
      trigger: /* @__PURE__ */ r("div", { children: /* @__PURE__ */ r(L, { children: /* @__PURE__ */ r("div", { className: "size-fit border shrink-0 rounded-2xl overflow-hidden", children: i && /* @__PURE__ */ r("img", { src: s, className: "object-cover size-16", alt: o }) }) }) }),
      children: /* @__PURE__ */ r(
        kt,
        {
          className: "size-full max-w-full rounded-3xl flex items-center justify-center bg-transparent border-none gap-0",
          withClose: !0,
          children: i && /* @__PURE__ */ r("div", { className: "size-fit shrink-0 rounded-2xl overflow-hidden max-h-full", children: /* @__PURE__ */ r("img", { src: s, className: "object-cover size-auto", alt: o }) })
        }
      )
    }
  );
}
const Mt = U.memo(
  Ir,
  (e, o) => e.children === o.children && e.className === o.className
);
function be({
  children: e,
  messageType: o,
  messageId: t
}) {
  const { anchorTarget: n } = b();
  return /* @__PURE__ */ r(
    Mt,
    {
      "data-type": o,
      "data-id": t,
      remarkPlugins: [vt],
      rehypePlugins: [xt],
      components: {
        a: ({ children: s, ...i }) => /* @__PURE__ */ r("a", { target: i.target || n || "_top", ...i, children: s })
      },
      children: e
    }
  );
}
function Z() {
  const {
    widgetCtx: { org: e }
  } = j(), {
    sessionState: { session: o }
  } = $(), t = b(), {
    messagesState: { messages: n }
  } = E(), {
    routerState: { screen: s }
  } = A();
  return {
    react: U,
    org: e,
    session: o,
    config: t,
    messages: n,
    currentScreen: s
  };
}
function $r({
  currentMessage: e
}) {
  var n;
  const o = Z(), t = (n = o.config.customComponents) == null ? void 0 : n["message::after"];
  return t ? /* @__PURE__ */ r(t, { ...o, currentMessage: e }) : null;
}
function ge(e) {
  const {
    data: o,
    id: t,
    type: n,
    attachments: s,
    isFirstInGroup: i,
    isLastInGroup: a,
    isAloneInGroup: l,
    dataComponentNames: d,
    classNames: h
  } = e;
  if (n !== "AI" && n !== "AGENT") return null;
  const { message: y, variant: x = "default" } = o;
  return /* @__PURE__ */ c(
    "div",
    {
      ...g((d == null ? void 0 : d.messageContainer) ?? "chat/agent_msg/root"),
      className: p(
        "w-5/6 flex flex-col items-start gap-1",
        h == null ? void 0 : h.messageContainer
      ),
      children: [
        s && s.length > 0 && /* @__PURE__ */ r("div", { className: "w-full gap-1 flex flex-row flex-wrap items-center justify-start", children: s == null ? void 0 : s.map((m) => /* @__PURE__ */ r(Tt, { attachment: m }, m.id)) }),
        y.length > 0 && /* @__PURE__ */ c("div", { className: "flex flex-row gap-2", children: [
          /* @__PURE__ */ r(
            "div",
            {
              ...g((d == null ? void 0 : d.message) ?? "chat/agent_msg/msg"),
              "data-first": i,
              "data-last": a,
              "data-alone": l,
              "data-variant": x,
              className: p(
                "transition-all",
                "w-fit py-3 px-4 rounded-3xl bg-secondary text-secondary-foreground",
                "leading-snug text-sm prose prose-sm prose-a:decoration-primary prose-a:underline",
                "break-words [word-break:break-word]",
                // `[word-break:break-word]` is deprecated but works in the browser, while `break-words` which is `[overflow-wrap: break-word]` does not work
                // No need to add "whitespace-pre-wrap" in the agent or bot message because it is markup and content appear on separate lines as expected
                // Adding "whitespace-pre-wrap" will result in unnecessarily huge line breaks
                x === "error" && "bg-destructive/15 text-destructive",
                // We're using the booleans directly here, not the data attributes, to make any external styling more specific than this
                i && !l && "rounded-bl-md",
                a && !l && "rounded-tl-md",
                !i && !a && !l && "rounded-l-md",
                h == null ? void 0 : h.message
              ),
              children: /* @__PURE__ */ r(be, { messageType: n, messageId: t, children: y })
            }
          ),
          /* @__PURE__ */ r($r, { currentMessage: e })
        ] })
      ]
    }
  );
}
function Br(e) {
  return /* @__PURE__ */ r("div", { className: "w-full max-w-full overflow-auto shrink-0", children: /* @__PURE__ */ r("pre", { className: "text-xs leading-tight whitespace-pre-wrap break-word", children: JSON.stringify(e, null, 1) }) });
}
const ye = G.forwardRef(({ className: e, ...o }, t) => /* @__PURE__ */ r(
  Q.Root,
  {
    ref: t,
    className: p(
      "relative flex size-6 aspect-square shrink-0 overflow-hidden rounded-full bg-secondary",
      // 'border',
      e
    ),
    ...o
  }
));
ye.displayName = Q.Root.displayName;
const ke = G.forwardRef(({ className: e, ...o }, t) => /* @__PURE__ */ r(
  Q.Image,
  {
    ref: t,
    className: p("aspect-square h-full w-full", e),
    ...o
  }
));
ke.displayName = Q.Image.displayName;
const Ce = G.forwardRef(({ className: e, ...o }, t) => /* @__PURE__ */ r(
  Q.Fallback,
  {
    ref: t,
    className: p(
      "flex size-full text-xs items-center justify-center rounded-lg",
      e
    ),
    ...o
  }
));
Ce.displayName = Q.Fallback.displayName;
function we({
  agent: e,
  ...o
}) {
  var t, n;
  return /* @__PURE__ */ c(ye, { ...o, children: [
    /* @__PURE__ */ r(ke, { src: (e == null ? void 0 : e.avatarUrl) || (e == null ? void 0 : e.avatar) || "", alt: "Agent Icon" }),
    (e == null ? void 0 : e.name) && /* @__PURE__ */ r(Ce, { children: (n = (t = e == null ? void 0 : e.name) == null ? void 0 : t.slice(0, 1)) == null ? void 0 : n.toUpperCase() })
  ] });
}
function Yr({ agent: e }) {
  return /* @__PURE__ */ r(_, { children: /* @__PURE__ */ c(
    u,
    {
      ...g("chat/bot_loading/root"),
      className: "flex flex-row items-end w-full gap-2 animate-pulse",
      children: [
        /* @__PURE__ */ r(we, { agent: e }),
        /* @__PURE__ */ c(
          "div",
          {
            ...g("chat/bot_loading/bouncing_dots_container"),
            className: p(
              "flex items-center [&_span]:bg-secondary-foreground [&_span]:size-1 gap-1 p-2 rounded-xl bg-secondary"
              // 'border',
            ),
            children: [
              /* @__PURE__ */ r(J.span, { className: "rounded-full animate-bounce [animation-delay:-0.3s]" }),
              /* @__PURE__ */ r(J.span, { className: "rounded-full animate-bounce [animation-delay:-0.15s]" }),
              /* @__PURE__ */ r(J.span, { className: "rounded-full animate-bounce" })
            ]
          }
        )
      ]
    }
  ) });
}
const Dt = '*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}*{-ms-overflow-style:none;scrollbar-width:none}*::-webkit-scrollbar{display:none}*{border-color:hsl(var(--opencx-border))}.container{width:100%}@media (min-width: 640px){.container{max-width:640px}}@media (min-width: 768px){.container{max-width:768px}}@media (min-width: 1024px){.container{max-width:1024px}}@media (min-width: 1280px){.container{max-width:1280px}}@media (min-width: 1536px){.container{max-width:1536px}}.prose{color:var(--tw-prose-body);max-width:65ch}.prose :where(p):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em;margin-bottom:1.25em}.prose :where([class~=lead]):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-lead);font-size:1.25em;line-height:1.6;margin-top:1.2em;margin-bottom:1.2em}.prose :where(a):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-links);text-decoration:underline;font-weight:500}.prose :where(strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-bold);font-weight:600}.prose :where(a strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(blockquote strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(thead th strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(ol):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:decimal;margin-top:1.25em;margin-bottom:1.25em;padding-inline-start:1.625em}.prose :where(ol[type=A]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-alpha}.prose :where(ol[type=a]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-alpha}.prose :where(ol[type=A s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-alpha}.prose :where(ol[type=a s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-alpha}.prose :where(ol[type=I]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-roman}.prose :where(ol[type=i]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-roman}.prose :where(ol[type=I s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-roman}.prose :where(ol[type=i s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-roman}.prose :where(ol[type="1"]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:decimal}.prose :where(ul):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:disc;margin-top:1.25em;margin-bottom:1.25em;padding-inline-start:1.625em}.prose :where(ol>li):not(:where([class~=not-prose],[class~=not-prose] *))::marker{font-weight:400;color:var(--tw-prose-counters)}.prose :where(ul>li):not(:where([class~=not-prose],[class~=not-prose] *))::marker{color:var(--tw-prose-bullets)}.prose :where(dt):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-weight:600;margin-top:1.25em}.prose :where(hr):not(:where([class~=not-prose],[class~=not-prose] *)){border-color:var(--tw-prose-hr);border-top-width:1px;margin-top:3em;margin-bottom:3em}.prose :where(blockquote):not(:where([class~=not-prose],[class~=not-prose] *)){font-weight:500;font-style:italic;color:var(--tw-prose-quotes);border-inline-start-width:.25rem;border-inline-start-color:var(--tw-prose-quote-borders);quotes:"“""”""‘""’";margin-top:1.6em;margin-bottom:1.6em;padding-inline-start:1em}.prose :where(blockquote p:first-of-type):not(:where([class~=not-prose],[class~=not-prose] *)):before{content:open-quote}.prose :where(blockquote p:last-of-type):not(:where([class~=not-prose],[class~=not-prose] *)):after{content:close-quote}.prose :where(h1):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-weight:800;font-size:2.25em;margin-top:0;margin-bottom:.8888889em;line-height:1.1111111}.prose :where(h1 strong):not(:where([class~=not-prose],[class~=not-prose] *)){font-weight:900;color:inherit}.prose :where(h2):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-weight:700;font-size:1.5em;margin-top:2em;margin-bottom:1em;line-height:1.3333333}.prose :where(h2 strong):not(:where([class~=not-prose],[class~=not-prose] *)){font-weight:800;color:inherit}.prose :where(h3):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-weight:600;font-size:1.25em;margin-top:1.6em;margin-bottom:.6em;line-height:1.6}.prose :where(h3 strong):not(:where([class~=not-prose],[class~=not-prose] *)){font-weight:700;color:inherit}.prose :where(h4):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-weight:600;margin-top:1.5em;margin-bottom:.5em;line-height:1.5}.prose :where(h4 strong):not(:where([class~=not-prose],[class~=not-prose] *)){font-weight:700;color:inherit}.prose :where(img):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:2em;margin-bottom:2em}.prose :where(picture):not(:where([class~=not-prose],[class~=not-prose] *)){display:block;margin-top:2em;margin-bottom:2em}.prose :where(video):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:2em;margin-bottom:2em}.prose :where(kbd):not(:where([class~=not-prose],[class~=not-prose] *)){font-weight:500;font-family:inherit;color:var(--tw-prose-kbd);box-shadow:0 0 0 1px rgb(var(--tw-prose-kbd-shadows) / 10%),0 3px rgb(var(--tw-prose-kbd-shadows) / 10%);font-size:.875em;border-radius:.3125rem;padding-top:.1875em;padding-inline-end:.375em;padding-bottom:.1875em;padding-inline-start:.375em}.prose :where(code):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-code);font-weight:600;font-size:.875em}.prose :where(code):not(:where([class~=not-prose],[class~=not-prose] *)):before{content:"`"}.prose :where(code):not(:where([class~=not-prose],[class~=not-prose] *)):after{content:"`"}.prose :where(a code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(h1 code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(h2 code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-size:.875em}.prose :where(h3 code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-size:.9em}.prose :where(h4 code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(blockquote code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(thead th code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(pre):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-pre-code);background-color:var(--tw-prose-pre-bg);overflow-x:auto;font-weight:400;font-size:.875em;line-height:1.7142857;margin-top:1.7142857em;margin-bottom:1.7142857em;border-radius:.375rem;padding-top:.8571429em;padding-inline-end:1.1428571em;padding-bottom:.8571429em;padding-inline-start:1.1428571em}.prose :where(pre code):not(:where([class~=not-prose],[class~=not-prose] *)){background-color:transparent;border-width:0;border-radius:0;padding:0;font-weight:inherit;color:inherit;font-size:inherit;font-family:inherit;line-height:inherit}.prose :where(pre code):not(:where([class~=not-prose],[class~=not-prose] *)):before{content:none}.prose :where(pre code):not(:where([class~=not-prose],[class~=not-prose] *)):after{content:none}.prose :where(table):not(:where([class~=not-prose],[class~=not-prose] *)){width:100%;table-layout:auto;margin-top:2em;margin-bottom:2em;font-size:.875em;line-height:1.7142857}.prose :where(thead):not(:where([class~=not-prose],[class~=not-prose] *)){border-bottom-width:1px;border-bottom-color:var(--tw-prose-th-borders)}.prose :where(thead th):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-weight:600;vertical-align:bottom;padding-inline-end:.5714286em;padding-bottom:.5714286em;padding-inline-start:.5714286em}.prose :where(tbody tr):not(:where([class~=not-prose],[class~=not-prose] *)){border-bottom-width:1px;border-bottom-color:var(--tw-prose-td-borders)}.prose :where(tbody tr:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){border-bottom-width:0}.prose :where(tbody td):not(:where([class~=not-prose],[class~=not-prose] *)){vertical-align:baseline}.prose :where(tfoot):not(:where([class~=not-prose],[class~=not-prose] *)){border-top-width:1px;border-top-color:var(--tw-prose-th-borders)}.prose :where(tfoot td):not(:where([class~=not-prose],[class~=not-prose] *)){vertical-align:top}.prose :where(th,td):not(:where([class~=not-prose],[class~=not-prose] *)){text-align:start}.prose :where(figure>*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0;margin-bottom:0}.prose :where(figcaption):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-captions);font-size:.875em;line-height:1.4285714;margin-top:.8571429em}.prose{--tw-prose-body: #374151;--tw-prose-headings: #111827;--tw-prose-lead: #4b5563;--tw-prose-links: #111827;--tw-prose-bold: #111827;--tw-prose-counters: #6b7280;--tw-prose-bullets: #d1d5db;--tw-prose-hr: #e5e7eb;--tw-prose-quotes: #111827;--tw-prose-quote-borders: #e5e7eb;--tw-prose-captions: #6b7280;--tw-prose-kbd: #111827;--tw-prose-kbd-shadows: 17 24 39;--tw-prose-code: #111827;--tw-prose-pre-code: #e5e7eb;--tw-prose-pre-bg: #1f2937;--tw-prose-th-borders: #d1d5db;--tw-prose-td-borders: #e5e7eb;--tw-prose-invert-body: #d1d5db;--tw-prose-invert-headings: #fff;--tw-prose-invert-lead: #9ca3af;--tw-prose-invert-links: #fff;--tw-prose-invert-bold: #fff;--tw-prose-invert-counters: #9ca3af;--tw-prose-invert-bullets: #4b5563;--tw-prose-invert-hr: #374151;--tw-prose-invert-quotes: #f3f4f6;--tw-prose-invert-quote-borders: #374151;--tw-prose-invert-captions: #9ca3af;--tw-prose-invert-kbd: #fff;--tw-prose-invert-kbd-shadows: 255 255 255;--tw-prose-invert-code: #fff;--tw-prose-invert-pre-code: #d1d5db;--tw-prose-invert-pre-bg: rgb(0 0 0 / 50%);--tw-prose-invert-th-borders: #4b5563;--tw-prose-invert-td-borders: #374151;font-size:1rem;line-height:1.75}.prose :where(picture>img):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0;margin-bottom:0}.prose :where(li):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.5em;margin-bottom:.5em}.prose :where(ol>li):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-start:.375em}.prose :where(ul>li):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-start:.375em}.prose :where(.prose>ul>li p):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.75em;margin-bottom:.75em}.prose :where(.prose>ul>li>p:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em}.prose :where(.prose>ul>li>p:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em}.prose :where(.prose>ol>li>p:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em}.prose :where(.prose>ol>li>p:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em}.prose :where(ul ul,ul ol,ol ul,ol ol):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.75em;margin-bottom:.75em}.prose :where(dl):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em;margin-bottom:1.25em}.prose :where(dd):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.5em;padding-inline-start:1.625em}.prose :where(hr+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(h2+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(h3+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(h4+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(thead th:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-start:0}.prose :where(thead th:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-end:0}.prose :where(tbody td,tfoot td):not(:where([class~=not-prose],[class~=not-prose] *)){padding-top:.5714286em;padding-inline-end:.5714286em;padding-bottom:.5714286em;padding-inline-start:.5714286em}.prose :where(tbody td:first-child,tfoot td:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-start:0}.prose :where(tbody td:last-child,tfoot td:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-end:0}.prose :where(figure):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:2em;margin-bottom:2em}.prose :where(.prose>:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(.prose>:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:0}.prose-sm{font-size:.875rem;line-height:1.7142857}.prose-sm :where(p):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.1428571em;margin-bottom:1.1428571em}.prose-sm :where([class~=lead]):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:1.2857143em;line-height:1.5555556;margin-top:.8888889em;margin-bottom:.8888889em}.prose-sm :where(blockquote):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.3333333em;margin-bottom:1.3333333em;padding-inline-start:1.1111111em}.prose-sm :where(h1):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:2.1428571em;margin-top:0;margin-bottom:.8em;line-height:1.2}.prose-sm :where(h2):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:1.4285714em;margin-top:1.6em;margin-bottom:.8em;line-height:1.4}.prose-sm :where(h3):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:1.2857143em;margin-top:1.5555556em;margin-bottom:.4444444em;line-height:1.5555556}.prose-sm :where(h4):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.4285714em;margin-bottom:.5714286em;line-height:1.4285714}.prose-sm :where(img):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.7142857em;margin-bottom:1.7142857em}.prose-sm :where(picture):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.7142857em;margin-bottom:1.7142857em}.prose-sm :where(picture>img):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0;margin-bottom:0}.prose-sm :where(video):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.7142857em;margin-bottom:1.7142857em}.prose-sm :where(kbd):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.8571429em;border-radius:.3125rem;padding-top:.1428571em;padding-inline-end:.3571429em;padding-bottom:.1428571em;padding-inline-start:.3571429em}.prose-sm :where(code):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.8571429em}.prose-sm :where(h2 code):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.9em}.prose-sm :where(h3 code):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.8888889em}.prose-sm :where(pre):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.8571429em;line-height:1.6666667;margin-top:1.6666667em;margin-bottom:1.6666667em;border-radius:.25rem;padding-top:.6666667em;padding-inline-end:1em;padding-bottom:.6666667em;padding-inline-start:1em}.prose-sm :where(ol):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.1428571em;margin-bottom:1.1428571em;padding-inline-start:1.5714286em}.prose-sm :where(ul):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.1428571em;margin-bottom:1.1428571em;padding-inline-start:1.5714286em}.prose-sm :where(li):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.2857143em;margin-bottom:.2857143em}.prose-sm :where(ol>li):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-start:.4285714em}.prose-sm :where(ul>li):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-start:.4285714em}.prose-sm :where(.prose-sm>ul>li p):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.5714286em;margin-bottom:.5714286em}.prose-sm :where(.prose-sm>ul>li>p:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.1428571em}.prose-sm :where(.prose-sm>ul>li>p:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.1428571em}.prose-sm :where(.prose-sm>ol>li>p:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.1428571em}.prose-sm :where(.prose-sm>ol>li>p:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.1428571em}.prose-sm :where(ul ul,ul ol,ol ul,ol ol):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.5714286em;margin-bottom:.5714286em}.prose-sm :where(dl):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.1428571em;margin-bottom:1.1428571em}.prose-sm :where(dt):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.1428571em}.prose-sm :where(dd):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.2857143em;padding-inline-start:1.5714286em}.prose-sm :where(hr):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:2.8571429em;margin-bottom:2.8571429em}.prose-sm :where(hr+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose-sm :where(h2+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose-sm :where(h3+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose-sm :where(h4+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose-sm :where(table):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.8571429em;line-height:1.5}.prose-sm :where(thead th):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-end:1em;padding-bottom:.6666667em;padding-inline-start:1em}.prose-sm :where(thead th:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-start:0}.prose-sm :where(thead th:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-end:0}.prose-sm :where(tbody td,tfoot td):not(:where([class~=not-prose],[class~=not-prose] *)){padding-top:.6666667em;padding-inline-end:1em;padding-bottom:.6666667em;padding-inline-start:1em}.prose-sm :where(tbody td:first-child,tfoot td:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-start:0}.prose-sm :where(tbody td:last-child,tfoot td:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-end:0}.prose-sm :where(figure):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.7142857em;margin-bottom:1.7142857em}.prose-sm :where(figure>*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0;margin-bottom:0}.prose-sm :where(figcaption):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.8571429em;line-height:1.3333333;margin-top:.6666667em}.prose-sm :where(.prose-sm>:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose-sm :where(.prose-sm>:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:0}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.pointer-events-none{pointer-events:none}.visible{visibility:visible}.invisible{visibility:hidden}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.sticky{position:sticky}.inset-0{top:0;right:0;bottom:0;left:0}.bottom-0{bottom:0}.end-6{inset-inline-end:1.5rem}.left-2{left:.5rem}.left-\\[50\\%\\]{left:50%}.right-4{right:1rem}.top-4{top:1rem}.top-6{top:1.5rem}.top-\\[50\\%\\]{top:50%}.isolate{isolation:isolate}.z-10{z-index:10}.z-50{z-index:50}.m-2{margin:.5rem}.-mx-1{margin-left:-.25rem;margin-right:-.25rem}.mx-auto{margin-left:auto;margin-right:auto}.my-1{margin-top:.25rem;margin-bottom:.25rem}.mb-2{margin-bottom:.5rem}.ms-auto{margin-inline-start:auto}.mt-0\\.5{margin-top:.125rem}.mt-auto{margin-top:auto}.line-clamp-1{overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1}.line-clamp-2{overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2}.block{display:block}.inline-block{display:inline-block}.inline{display:inline}.flex{display:flex}.inline-flex{display:inline-flex}.hidden{display:none}.aspect-square{aspect-ratio:1 / 1}.size-0{width:0px;height:0px}.size-10{width:2.5rem;height:2.5rem}.size-12{width:3rem;height:3rem}.size-16{width:4rem;height:4rem}.size-3{width:.75rem;height:.75rem}.size-4{width:1rem;height:1rem}.size-6{width:1.5rem;height:1.5rem}.size-8{width:2rem;height:2rem}.size-auto{width:auto;height:auto}.size-fit{width:fit-content;height:fit-content}.size-full{width:100%;height:100%}.h-0{height:0px}.h-10{height:2.5rem}.h-2{height:.5rem}.h-3\\.5{height:.875rem}.h-4{height:1rem}.h-5{height:1.25rem}.h-8{height:2rem}.h-dvh{height:100dvh}.h-full{height:100%}.h-px{height:1px}.max-h-16{max-height:4rem}.max-h-40{max-height:10rem}.max-h-full{max-height:100%}.min-h-12{min-height:3rem}.w-0{width:0px}.w-1\\/2{width:50%}.w-10{width:2.5rem}.w-2{width:.5rem}.w-2\\/5{width:40%}.w-3\\.5{width:.875rem}.w-3\\/5{width:60%}.w-4{width:1rem}.w-5\\/6{width:83.333333%}.w-60{width:15rem}.w-9{width:2.25rem}.w-auto{width:auto}.w-dvw{width:100dvw}.w-fit{width:fit-content}.w-full{width:100%}.min-w-80{min-width:20rem}.min-w-\\[8rem\\]{min-width:8rem}.max-w-96{max-width:24rem}.max-w-\\[61\\.8\\%\\]{max-width:61.8%}.max-w-full{max-width:100%}.max-w-xs{max-width:20rem}.flex-1{flex:1 1 0%}.flex-\\[2\\]{flex:2}.shrink-0{flex-shrink:0}.translate-x-\\[-50\\%\\]{--tw-translate-x: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-x-\\[var\\(--wobble-x\\)\\]{--tw-translate-x: var(--wobble-x);transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-y-\\[-50\\%\\]{--tw-translate-y: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-y-\\[var\\(--wobble-y\\)\\]{--tw-translate-y: var(--wobble-y);transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@keyframes bounce{0%,to{transform:translateY(-25%);animation-timing-function:cubic-bezier(.8,0,1,1)}50%{transform:none;animation-timing-function:cubic-bezier(0,0,.2,1)}}.animate-bounce{animation:bounce 1s infinite}@keyframes pulse{50%{opacity:.5}}.animate-pulse{animation:pulse 2s cubic-bezier(.4,0,.6,1) infinite}@keyframes spin{to{transform:rotate(360deg)}}.animate-spin{animation:spin 1s linear infinite}.cursor-default{cursor:default}.cursor-pointer{cursor:pointer}.select-none{-webkit-user-select:none;user-select:none}.resize-none{resize:none}.resize{resize:both}.flex-row{flex-direction:row}.flex-col{flex-direction:column}.flex-wrap{flex-wrap:wrap}.items-start{align-items:flex-start}.items-end{align-items:flex-end}.items-center{align-items:center}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-0{gap:0px}.gap-1{gap:.25rem}.gap-2{gap:.5rem}.gap-4{gap:1rem}.gap-\\[1px\\]{gap:1px}.space-y-1>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.25rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(.25rem * var(--tw-space-y-reverse))}.space-y-2>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.5rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(.5rem * var(--tw-space-y-reverse))}.space-y-4>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1rem * var(--tw-space-y-reverse))}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-scroll{overflow:scroll}.scroll-smooth{scroll-behavior:smooth}.text-ellipsis{text-overflow:ellipsis}.whitespace-normal{white-space:normal}.whitespace-nowrap{white-space:nowrap}.whitespace-pre-wrap{white-space:pre-wrap}.break-words{overflow-wrap:break-word}.rounded-2xl{border-radius:1rem}.rounded-3xl{border-radius:1.5rem}.rounded-\\[20px\\]{border-radius:20px}.rounded-full{border-radius:9999px}.rounded-lg{border-radius:.5rem}.rounded-md{border-radius:.375rem}.rounded-sm{border-radius:.125rem}.rounded-xl{border-radius:.75rem}.rounded-l-md{border-top-left-radius:.375rem;border-bottom-left-radius:.375rem}.rounded-r-md{border-top-right-radius:.375rem;border-bottom-right-radius:.375rem}.rounded-bl-md{border-bottom-left-radius:.375rem}.rounded-br-md{border-bottom-right-radius:.375rem}.rounded-tl-md{border-top-left-radius:.375rem}.rounded-tr-md{border-top-right-radius:.375rem}.border{border-width:1px}.border-2{border-width:2px}.border-none{border-style:none}.border-transparent{border-color:transparent}.bg-\\[white\\]{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1))}.bg-background{background-color:hsl(var(--opencx-background))}.bg-black\\/50{background-color:#00000080}.bg-black\\/60{background-color:#0009}.bg-destructive{background-color:hsl(var(--opencx-destructive))}.bg-destructive\\/15{background-color:hsl(var(--opencx-destructive) / .15)}.bg-muted{background-color:hsl(var(--opencx-muted))}.bg-primary{background-color:hsl(var(--opencx-primary))}.bg-secondary{background-color:hsl(var(--opencx-secondary))}.bg-transparent{background-color:transparent}.bg-white{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1))}.bg-\\[radial-gradient\\(ellipse_at_top_left\\,hsl\\(var\\(--opencx-primary\\)\\)\\,transparent\\)\\,radial-gradient\\(ellipse_at_top_right\\,hsl\\(var\\(--opencx-primary\\)\\)\\,transparent\\)\\]{background-image:radial-gradient(ellipse at top left,hsl(var(--opencx-primary)),transparent),radial-gradient(ellipse at top right,hsl(var(--opencx-primary)),transparent)}.fill-current{fill:currentColor}.object-contain{object-fit:contain}.object-cover{object-fit:cover}.p-0{padding:0}.p-1{padding:.25rem}.p-2{padding:.5rem}.p-4{padding:1rem}.p-8{padding:2rem}.px-2{padding-left:.5rem;padding-right:.5rem}.px-3\\.5{padding-left:.875rem;padding-right:.875rem}.px-4{padding-left:1rem;padding-right:1rem}.py-1\\.5{padding-top:.375rem;padding-bottom:.375rem}.py-12{padding-top:3rem;padding-bottom:3rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.pb-0{padding-bottom:0}.pb-2{padding-bottom:.5rem}.pe-2{padding-inline-end:.5rem}.pe-4{padding-inline-end:1rem}.ps-2{padding-inline-start:.5rem}.ps-4{padding-inline-start:1rem}.ps-8{padding-inline-start:2rem}.pt-0{padding-top:0}.pt-1{padding-top:.25rem}.pt-2{padding-top:.5rem}.text-center{text-align:center}.text-start{text-align:start}.align-middle{vertical-align:middle}.font-sans{font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji"}.text-2xl{font-size:1.5rem;line-height:2rem}.text-4xl{font-size:2.25rem;line-height:2.5rem}.text-\\[1\\.75rem\\]{font-size:1.75rem}.text-\\[10px\\]{font-size:10px}.text-\\[16px\\]{font-size:16px}.text-lg{font-size:1.125rem;line-height:1.75rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-xs{font-size:.75rem;line-height:1rem}.font-bold{font-weight:700}.font-medium{font-weight:500}.font-semibold{font-weight:600}.uppercase{text-transform:uppercase}.leading-none{line-height:1}.leading-snug{line-height:1.375}.leading-tight{line-height:1.25}.tracking-tight{letter-spacing:-.025em}.tracking-widest{letter-spacing:.1em}.text-blue-500{--tw-text-opacity: 1;color:rgb(59 130 246 / var(--tw-text-opacity, 1))}.text-destructive{color:hsl(var(--opencx-destructive))}.text-destructive-foreground{color:hsl(var(--opencx-destructive-foreground))}.text-emerald-600{--tw-text-opacity: 1;color:rgb(5 150 105 / var(--tw-text-opacity, 1))}.text-foreground{color:hsl(var(--opencx-foreground))}.text-muted-foreground{color:hsl(var(--opencx-muted-foreground))}.text-muted-foreground\\/70{color:hsl(var(--opencx-muted-foreground) / .7)}.text-muted-foreground\\/75{color:hsl(var(--opencx-muted-foreground) / .75)}.text-primary{color:hsl(var(--opencx-primary))}.text-primary-foreground{color:hsl(var(--opencx-primary-foreground))}.text-secondary-foreground{color:hsl(var(--opencx-secondary-foreground))}.underline{text-decoration-line:underline}.underline-offset-4{text-underline-offset:4px}.antialiased{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.opacity-0{opacity:0}.opacity-100{opacity:1}.opacity-35{opacity:.35}.opacity-50{opacity:.5}.opacity-60{opacity:.6}.opacity-95{opacity:.95}.shadow{--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / .1), 0 1px 2px -1px rgb(0 0 0 / .1);--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-2xl{--tw-shadow: 0 25px 50px -12px rgb(0 0 0 / .25);--tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-sm{--tw-shadow: 0 1px 2px 0 rgb(0 0 0 / .05);--tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.outline-none{outline:2px solid transparent;outline-offset:2px}.outline{outline-style:solid}.outline-8{outline-width:8px}.outline-background{outline-color:hsl(var(--opencx-background))}.ring-0{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.ring-offset-background{--tw-ring-offset-color: hsl(var(--opencx-background))}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.backdrop-blur-sm{--tw-backdrop-blur: blur(4px);-webkit-backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)}.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-\\[height\\]{transition-property:height;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-all{transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-colors{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-transform{transition-property:transform;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}@keyframes enter{0%{opacity:var(--tw-enter-opacity, 1);transform:translate3d(var(--tw-enter-translate-x, 0),var(--tw-enter-translate-y, 0),0) scale3d(var(--tw-enter-scale, 1),var(--tw-enter-scale, 1),var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0))}}@keyframes exit{to{opacity:var(--tw-exit-opacity, 1);transform:translate3d(var(--tw-exit-translate-x, 0),var(--tw-exit-translate-y, 0),0) scale3d(var(--tw-exit-scale, 1),var(--tw-exit-scale, 1),var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0))}}.animate-in{animation-name:enter;animation-duration:.15s;--tw-enter-opacity: initial;--tw-enter-scale: initial;--tw-enter-rotate: initial;--tw-enter-translate-x: initial;--tw-enter-translate-y: initial}.fade-in-0{--tw-enter-opacity: 0}.zoom-in-95{--tw-enter-scale: .95}.ease-out{animation-timing-function:cubic-bezier(0,0,.2,1)}.\\[animation-delay\\:-0\\.15s\\]{animation-delay:-.15s}.\\[animation-delay\\:-0\\.3s\\]{animation-delay:-.3s}.\\[field-sizing\\:content\\;\\],.\\[field-sizing\\:content\\]{field-sizing:content}.\\[word-break\\:break-word\\]{word-break:break-word}.file\\:border-0::file-selector-button{border-width:0px}.file\\:bg-transparent::file-selector-button{background-color:transparent}.file\\:text-sm::file-selector-button{font-size:.875rem;line-height:1.25rem}.file\\:font-medium::file-selector-button{font-weight:500}.file\\:text-primary-foreground::file-selector-button{color:hsl(var(--opencx-primary-foreground))}.placeholder\\:text-muted-foreground::placeholder{color:hsl(var(--opencx-muted-foreground))}.placeholder\\:text-muted-foreground\\/75::placeholder{color:hsl(var(--opencx-muted-foreground) / .75)}.focus-within\\:border-primary:focus-within{border-color:hsl(var(--opencx-primary))}.hover\\:scale-\\[var\\(--scale\\)\\]:hover{--tw-scale-x: var(--scale);--tw-scale-y: var(--scale);transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.hover\\:border-primary:hover{border-color:hsl(var(--opencx-primary))}.hover\\:bg-secondary:hover{background-color:hsl(var(--opencx-secondary))}.hover\\:text-blue-600:hover{--tw-text-opacity: 1;color:rgb(37 99 235 / var(--tw-text-opacity, 1))}.hover\\:text-primary:hover{color:hsl(var(--opencx-primary))}.hover\\:underline:hover{text-decoration-line:underline}.hover\\:opacity-100:hover{opacity:1}.focus\\:bg-accent:focus{background-color:hsl(var(--opencx-accent))}.focus\\:text-accent-foreground:focus{color:hsl(var(--opencx-accent-foreground))}.focus-visible\\:outline-none:focus-visible{outline:2px solid transparent;outline-offset:2px}.focus-visible\\:ring-2:focus-visible{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.focus-visible\\:ring-ring:focus-visible{--tw-ring-color: hsl(var(--opencx-ring))}.focus-visible\\:ring-offset-2:focus-visible{--tw-ring-offset-width: 2px}.focus-visible\\:ring-offset-background:focus-visible{--tw-ring-offset-color: hsl(var(--opencx-background))}.active\\:scale-95:active{--tw-scale-x: .95;--tw-scale-y: .95;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.active\\:hover\\:scale-\\[calc\\(var\\(--scale\\)-0\\.02\\)\\]:hover:active{--tw-scale-x: calc(var(--scale) - .02);--tw-scale-y: calc(var(--scale) - .02);transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.hover\\:active\\:scale-95:active:hover{--tw-scale-x: .95;--tw-scale-y: .95;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.disabled\\:pointer-events-none:disabled{pointer-events:none}.disabled\\:cursor-not-allowed:disabled{cursor:not-allowed}.disabled\\:opacity-50:disabled{opacity:.5}.group:hover .group-hover\\:opacity-100{opacity:1}.group:hover .group-hover\\:active\\:scale-90:active,.group:active .group-active\\:scale-90{--tw-scale-x: .9;--tw-scale-y: .9;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{pointer-events:none}.data-\\[state\\=checked\\]\\:translate-x-4[data-state=checked]{--tw-translate-x: 1rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state=unchecked]{--tw-translate-x: 0px;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.data-\\[state\\=checked\\]\\:bg-primary[data-state=checked]{background-color:hsl(var(--opencx-primary))}.data-\\[state\\=open\\]\\:bg-accent[data-state=open]{background-color:hsl(var(--opencx-accent))}.data-\\[state\\=unchecked\\]\\:bg-input[data-state=unchecked]{background-color:hsl(var(--opencx-input))}.data-\\[disabled\\]\\:opacity-50[data-disabled]{opacity:.5}.data-\\[state\\=open\\]\\:animate-in[data-state=open]{animation-name:enter;animation-duration:.15s;--tw-enter-opacity: initial;--tw-enter-scale: initial;--tw-enter-rotate: initial;--tw-enter-translate-x: initial;--tw-enter-translate-y: initial}.data-\\[state\\=closed\\]\\:animate-out[data-state=closed]{animation-name:exit;animation-duration:.15s;--tw-exit-opacity: initial;--tw-exit-scale: initial;--tw-exit-rotate: initial;--tw-exit-translate-x: initial;--tw-exit-translate-y: initial}.data-\\[state\\=closed\\]\\:fade-out-0[data-state=closed]{--tw-exit-opacity: 0}.data-\\[state\\=open\\]\\:fade-in-0[data-state=open]{--tw-enter-opacity: 0}.data-\\[state\\=closed\\]\\:zoom-out-95[data-state=closed]{--tw-exit-scale: .95}.data-\\[state\\=open\\]\\:zoom-in-95[data-state=open]{--tw-enter-scale: .95}.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side=bottom]{--tw-enter-translate-y: -.5rem}.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side=left]{--tw-enter-translate-x: .5rem}.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side=right]{--tw-enter-translate-x: -.5rem}.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side=top]{--tw-enter-translate-y: .5rem}.prose-a\\:underline :is(:where(a):not(:where([class~=not-prose],[class~=not-prose] *))){text-decoration-line:underline}.prose-a\\:decoration-primary :is(:where(a):not(:where([class~=not-prose],[class~=not-prose] *))){text-decoration-color:hsl(var(--opencx-primary))}.rtl\\:-scale-100:where([dir=rtl],[dir=rtl] *){--tw-scale-x: -1;--tw-scale-y: -1;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.\\[\\&_span\\]\\:size-1 span{width:.25rem;height:.25rem}.\\[\\&_span\\]\\:bg-secondary-foreground span{background-color:hsl(var(--opencx-secondary-foreground))}.\\[\\&_svg\\]\\:pointer-events-none svg{pointer-events:none}.\\[\\&_svg\\]\\:size-4 svg{width:1rem;height:1rem}.\\[\\&_svg\\]\\:shrink-0 svg{flex-shrink:0}.\\[\\&_svg\\]\\:text-muted-foreground\\/70 svg{color:hsl(var(--opencx-muted-foreground) / .7)}.\\[\\&_svg\\]\\:hover\\:text-primary:hover svg{color:hsl(var(--opencx-primary))}', Ur = ne.Provider, qr = ne.Root, Xr = ne.Trigger, jt = G.forwardRef(({ className: e, sideOffset: o = 4, ...t }, n) => /* @__PURE__ */ r(
  ne.Content,
  {
    ref: n,
    sideOffset: o,
    className: p(
      "z-50 overflow-hidden max-w-xs rounded-xl bg-primary border text-primary-foreground p-2 text-center align-middle text-xs animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
jt.displayName = ne.Content.displayName;
function ee({
  children: e,
  content: o,
  side: t,
  align: n
}) {
  const { disableTooltips: s } = b();
  return !o || s ? e : /* @__PURE__ */ c(qr, { children: [
    /* @__PURE__ */ r(Xr, { asChild: !0, children: e }),
    /* @__PURE__ */ r(
      jt,
      {
        side: t,
        align: n,
        collisionPadding: 8,
        avoidCollisions: !0,
        children: o
      }
    )
  ] });
}
const st = 450;
function F() {
  const [e, o] = U.useState(() => (window.top || window).innerWidth < st);
  return U.useEffect(() => {
    const t = window.top || window, n = () => {
      o(t.innerWidth < st);
    };
    return n(), t.addEventListener("resize", n), () => {
      t.removeEventListener("resize", n);
    };
  }, []), { isSmallScreen: e };
}
const ae = {
  transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
  transitionDuration: "1000ms"
};
function q() {
  var x, m, z, w, k, I, f, M, O, H, W, R, v, N, S, B, se, _e, Ie, Te, Me, De, je, Ee, Re, Pe, Ae, Fe, Oe, He, We, Le, $e, Be, Ye, Ue, qe, Xe, Ve, Ge, Ke, Qe, Ze, Je, et, tt, rt;
  const { dir: e } = ve(), { isSmallScreen: o } = F(), { theme: t, inline: n } = b(), s = (Y) => n ? "100%" : Y, i = (Y, he) => o ? `100dv${Y}` : he, a = (Y, he) => s(i(Y, he)), l = {
    zIndex: ((x = t == null ? void 0 : t.widgetTrigger) == null ? void 0 : x.zIndex) ?? 1e7,
    offset: {
      bottom: ((z = (m = t == null ? void 0 : t.widgetTrigger) == null ? void 0 : m.offset) == null ? void 0 : z.bottom) ?? 20,
      right: ((k = (w = t == null ? void 0 : t.widgetTrigger) == null ? void 0 : w.offset) == null ? void 0 : k.right) ?? (e === "ltr" ? 20 : "initial"),
      left: ((f = (I = t == null ? void 0 : t.widgetTrigger) == null ? void 0 : I.offset) == null ? void 0 : f.left) ?? (e === "rtl" ? 20 : "initial")
    },
    size: {
      button: ((O = (M = t == null ? void 0 : t.widgetTrigger) == null ? void 0 : M.size) == null ? void 0 : O.button) ?? 48,
      icon: ((W = (H = t == null ? void 0 : t.widgetTrigger) == null ? void 0 : H.size) == null ? void 0 : W.icon) ?? 24
    }
  }, d = (() => {
    const Y = e === "ltr" ? l.offset.right : l.offset.left;
    return typeof Y != "number" ? 0 : Y;
  })(), h = {
    palette: (t == null ? void 0 : t.palette) ?? "neutral",
    primaryColor: (t == null ? void 0 : t.primaryColor) ?? "hsl(0 0% 9%)",
    widgetTrigger: l,
    widgetContentContainer: {
      borderRadius: o ? "0px" : ((R = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : R.borderRadius) ?? "32px",
      zIndex: ((v = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : v.zIndex) ?? l.zIndex + 1,
      outline: ((N = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : N.outline) ?? "none",
      // was: '1px solid'
      outlineColor: ((S = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : S.outlineColor) ?? "hsl(0 0% 50% / .5)",
      boxShadow: ((B = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : B.boxShadow) ?? "0 0px 100px 0px rgb(0 0 0 / 0.25)",
      transitionProperty: ((se = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : se.transitionProperty) ?? "all",
      transitionTimingFunction: ((_e = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : _e.transitionTimingFunction) ?? ae.transitionTimingFunction,
      transitionDuration: ((Ie = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : Ie.transitionDuration) ?? ae.transitionDuration,
      offset: {
        side: o ? 0 : l.offset.bottom + l.size.button + V.y * 2 + (((Me = (Te = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : Te.offset) == null ? void 0 : Me.side) ?? 10),
        align: o ? 0 : d + (((je = (De = t == null ? void 0 : t.widgetContentContainer) == null ? void 0 : De.offset) == null ? void 0 : je.align) ?? 0)
      }
    },
    screens: {
      welcome: {
        width: a("w", ((Re = (Ee = t == null ? void 0 : t.screens) == null ? void 0 : Ee.welcome) == null ? void 0 : Re.width) ?? "400px"),
        // By setting minHeight to 1px, a nice animation will play from 1px to the dynamic height of the content of the screen
        minHeight: a(
          "h",
          ((Ae = (Pe = t == null ? void 0 : t.screens) == null ? void 0 : Pe.welcome) == null ? void 0 : Ae.minHeight) ?? "1px"
        )
      },
      sessions: {
        width: a("w", ((Oe = (Fe = t == null ? void 0 : t.screens) == null ? void 0 : Fe.sessions) == null ? void 0 : Oe.width) ?? "450px"),
        height: a("h", ((We = (He = t == null ? void 0 : t.screens) == null ? void 0 : He.sessions) == null ? void 0 : We.height) ?? "600px")
      },
      chat: {
        width: a("w", (($e = (Le = t == null ? void 0 : t.screens) == null ? void 0 : Le.chat) == null ? void 0 : $e.width) ?? "525px"),
        height: a("h", ((Ye = (Be = t == null ? void 0 : t.screens) == null ? void 0 : Be.chat) == null ? void 0 : Ye.height) ?? "700px"),
        withCanvas: {
          width: a(
            "w",
            ((Xe = (qe = (Ue = t == null ? void 0 : t.screens) == null ? void 0 : Ue.chat) == null ? void 0 : qe.withCanvas) == null ? void 0 : Xe.width) ?? "min(1050px, 100vw)"
          ),
          height: a(
            "h",
            ((Ke = (Ge = (Ve = t == null ? void 0 : t.screens) == null ? void 0 : Ve.chat) == null ? void 0 : Ge.withCanvas) == null ? void 0 : Ke.height) ?? "min(800px, 100vh)"
          ),
          transitionTimingFunction: ((Je = (Ze = (Qe = t == null ? void 0 : t.screens) == null ? void 0 : Qe.chat) == null ? void 0 : Ze.withCanvas) == null ? void 0 : Je.transitionTimingFunction) ?? ae.transitionTimingFunction,
          transitionDuration: ((rt = (tt = (et = t == null ? void 0 : t.screens) == null ? void 0 : et.chat) == null ? void 0 : tt.withCanvas) == null ? void 0 : rt.transitionDuration) ?? ae.transitionDuration
        }
      }
    }
  }, y = {
    // Subtract the offset.bottom twice so that it adds a bit of padding to the top
    // Subtract the distance between the trigger and the widget content container
    // Subtract the invisible padding of the trigger (for the wobble effect)
    maxHeight: a(
      "h",
      `calc(
        100vh 
        - ${h.widgetTrigger.offset.bottom}px
        - ${h.widgetContentContainer.offset.side}px
        - ${V.y * 2}px
      )`
    ),
    // Subtract the offset.right twice so that it adds a bit of padding to the left
    maxWidth: a(
      "w",
      `calc(
        100vw 
        - ${d * 2}px
      )`
    ),
    minHeight: a(
      "h",
      `min(
        ${h.screens.welcome.minHeight}, 
        ${h.screens.sessions.height}, 
        ${h.screens.chat.height}
      )`
    ),
    minWidth: a(
      "w",
      `min(
        ${h.screens.welcome.width}, 
        ${h.screens.sessions.width}, 
        ${h.screens.chat.width}
      )`
    )
  };
  return {
    theme: h,
    computed: y,
    cssVars: Vr({
      palette: h.palette,
      primary: h.primaryColor
    })
  };
}
function Vr({
  palette: e,
  primary: o
}) {
  const t = Et(e), n = nt(o).toHsl(), s = nt(o).isLight() ? t[950] : t[50];
  return {
    "--opencx-primary": `${n.h} ${n.s * 100}% ${n.l * 100}%`,
    "--opencx-primary-foreground": s,
    "--opencx-background": t[100],
    "--opencx-foreground": t[950],
    "--opencx-destructive": "0 72.2% 50.6%",
    "--opencx-destructive-foreground": t[50],
    "--opencx-accent": t[200],
    "--opencx-accent-foreground": "var(--opencx-foreground)",
    "--opencx-secondary": t[200],
    "--opencx-secondary-foreground": "var(--opencx-foreground)",
    "--opencx-muted": t[200],
    "--opencx-muted-foreground": t[500],
    "--opencx-input": t[300],
    "--opencx-border": t[300],
    "--opencx-ring": "var(--opencx-foreground)"
  };
}
function Et(e) {
  const o = {
    50: "0 0% 98%",
    100: "0 0% 96.1%",
    200: "0 0% 89.8%",
    300: "0 0% 83.1%",
    400: "0 0% 63.9%",
    500: "0 0% 45.1%",
    600: "0 0% 32.2%",
    700: "0 0% 25.1%",
    800: "0 0% 14.9%",
    900: "0 0% 9%",
    950: "0 0% 3.9%"
  }, t = {
    50: "60 9.1% 97.8%",
    100: "60 4.8% 95.9%",
    200: "20 5.9% 90%",
    300: "24 5.7% 82.9%",
    400: "24 5.4% 63.9%",
    500: "25 5.3% 44.7%",
    600: "33.3 5.5% 32.4%",
    700: "30 6.3% 25.1%",
    800: "12 6.5% 15.1%",
    900: "24 9.8% 10%",
    950: "20 14.3% 4.1%"
  }, n = {
    50: "0 0% 98%",
    100: "240 4.8% 95.9%",
    200: "240 5.9% 90%",
    300: "240 4.9% 83.9%",
    400: "240 5% 64.9%",
    500: "240 3.8% 46.1%",
    600: "240 5.2% 33.9%",
    700: "240 5.3% 26.1%",
    800: "240 3.7% 15.9%",
    900: "240 5.9% 10%",
    950: "240 10% 3.9%"
  }, s = {
    50: "210 40% 98%",
    100: "210 40% 96.1%",
    200: "214.3 31.8% 91.4%",
    300: "212.7 26.8% 83.9%",
    400: "215 20.2% 65.1%",
    500: "215.4 16.3% 46.9%",
    600: "215.3 19.3% 34.5%",
    700: "215.3 25% 26.7%",
    800: "217.2 32.6% 17.5%",
    900: "222.2 47.4% 11.2%",
    950: "222.2 84% 4.9%"
  };
  switch (e) {
    case "neutral":
      return o;
    case "stone":
      return t;
    case "zinc":
      return n;
    case "slate":
      return s;
    default:
      return D(e, Et.name), o;
  }
}
function Rt() {
  const { contentIframeRef: e } = j(), { inline: o } = b();
  return {
    setWidth: (t) => {
      var n;
      (n = e == null ? void 0 : e.current) == null || n.style.setProperty(
        "--opencx-widget-width",
        o ? "100%" : t
      );
    },
    setHeight: (t) => {
      var n;
      (n = e == null ? void 0 : e.current) == null || n.style.setProperty(
        "--opencx-widget-height",
        o ? "100%" : t
      );
    }
  };
}
function ze({
  width: e,
  height: o
}) {
  const { isSmallScreen: t } = F(), { setWidth: n, setHeight: s } = Rt();
  oe(() => {
    e && n(e), o && s(o);
  }, [t, o, e, n, s]);
}
const at = er;
function te({
  name: e,
  className: o
}) {
  const t = (() => {
    switch (e) {
      case "Check":
        return mr;
      case "CheckCheck":
        return hr;
      case "CircleCheck":
        return ut;
      case "CircleCheckBig":
        return pr;
      case "CircleX":
        return dr;
      case "Expand":
        return cr;
      case "Maximize":
        return lr;
      case "Maximize2":
        return ir;
      case "Minimize":
        return ar;
      case "Minimize2":
        return sr;
      case "Shrink":
        return nr;
      case "SquareCheck":
        return or;
      case "SquareCheckBig":
        return rr;
      case "SquareX":
        return tr;
      case "X":
        return xe;
      case void 0:
        return at;
      default:
        return D(e, te.name), at;
    }
  })();
  return /* @__PURE__ */ r(t, { className: p("size-4", o) });
}
function Gr() {
  var t;
  const e = Z(), o = (t = e.config.customComponents) == null ? void 0 : t.headerBottom;
  return o ? /* @__PURE__ */ r(o, { ...e }) : null;
}
function Kr({ fallback: e }) {
  var n;
  const o = Z(), t = (n = o.config.customComponents) == null ? void 0 : n.headerTitle;
  return t ? /* @__PURE__ */ r(t, { ...o }) : e;
}
function Ne() {
  const {
    widgetCtx: { org: e }
  } = j(), {
    routerState: { screen: o }
  } = A(), { textContent: t } = b();
  return (() => {
    var s, i;
    switch (o) {
      case "chat":
        return (s = t == null ? void 0 : t.chatScreen) == null ? void 0 : s.headerTitle;
      case "sessions":
        return (i = t == null ? void 0 : t.sessionsScreen) == null ? void 0 : i.headerTitle;
      case "welcome":
        return;
      default:
        D(o, Ne.name);
        return;
    }
  })() ?? e.name ?? "Chat";
}
function Qr(e) {
  switch (e) {
    case "chat":
      return g("chat/header");
    case "sessions":
      return g("sessions/header");
    case "welcome":
      return;
    default:
      D(e, Ne.name);
      return;
  }
}
function Zr() {
  const { router: e } = b(), {
    routerState: { screen: o },
    toSessionsScreen: t
  } = A();
  return o !== "chat" || e != null && e.chatScreenOnly ? null : /* @__PURE__ */ r(
    C,
    {
      variant: "ghost",
      size: "fit",
      className: "rounded-full",
      onClick: t,
      children: /* @__PURE__ */ r(gr, { className: "size-4 rtl:-scale-100" })
    }
  );
}
function Jr({
  button: e
}) {
  const { setIsOpen: o } = K(), { isSmallScreen: t } = F();
  return t && e.hideOnSmallScreen || !t && e.hideOnLargeScreen ? null : /* @__PURE__ */ r(
    C,
    {
      variant: "ghost",
      size: "fit",
      className: "rounded-full",
      onClick: () => {
        if (e.handleClick) return e.handleClick();
        o(!1);
      },
      children: /* @__PURE__ */ r(te, { name: e.icon })
    }
  );
}
function ue({
  button: e
}) {
  const [o, t] = T(!1), {
    routerState: { screen: n }
  } = A(), { isSmallScreen: s } = F(), { theme: i } = q(), { setWidth: a, setHeight: l } = Rt();
  if (n !== "chat" && n !== "sessions") return null;
  const d = (() => {
    switch (n) {
      case "chat":
        return i.screens.chat.height;
      case "sessions":
        return i.screens.sessions.height;
      default:
        return D(n, ue.name), i.screens.chat.height;
    }
  })(), h = (() => {
    switch (n) {
      case "chat":
        return i.screens.chat.width;
      case "sessions":
        return i.screens.sessions.width;
      default:
        return D(n, ue.name), i.screens.chat.width;
    }
  })(), y = () => {
    t((x) => {
      const m = !x;
      return l(m ? "100vh" : d), a(m ? `max(40vw, ${h})` : h), m;
    });
  };
  return s && e.hideOnSmallScreen || !s && e.hideOnLargeScreen ? null : /* @__PURE__ */ r(
    C,
    {
      variant: "ghost",
      size: "fit",
      className: "rounded-full",
      onClick: y,
      children: /* @__PURE__ */ r(
        te,
        {
          name: e.icon || (o ? e.shrinkIcon : e.expandIcon)
        }
      )
    }
  );
}
function Pt({
  button: e
}) {
  var k, I;
  const { close: o } = pe(), { widgetCtx: t } = j(), { setIsOpen: n } = K(), { resolveSession: s, sessionState: i } = $(), { isSmallScreen: a } = F(), l = !i.session, d = ((k = i.session) == null ? void 0 : k.isOpened) === !1, h = e.onResolved || "stay-in-chat", y = e.behaviorBeforeSessionCreation || "disabled", x = e.behaviorIfSessionIsResolved || "disabled", m = !!(i.isResolvingSession || l && y === "disabled" || d && x === "disabled"), z = async () => {
    const { success: f, error: M } = await s();
    if (o(), !f) return console.error(M);
    switch (h) {
      case "stay-in-chat":
        return;
      case "close-widget":
        n(!1);
        break;
      case "reset-chat":
        t.resetChat();
        break;
      case "reset-chat-and-close-widget":
        n(!1), t.resetChat();
        break;
      default:
        D(h, Pt.name);
        break;
    }
  }, w = () => {
    if (l)
      switch (y) {
        case "disabled":
          return;
        case "close-widget":
          n(!1);
          break;
        default:
          D(
            y,
            w.name
          );
      }
    if (d)
      switch (x) {
        case "disabled":
          return;
        case "close-widget":
          n(!1);
          break;
        case "reset-chat":
          t.resetChat();
          break;
        case "reset-chat-and-close-widget":
          n(!1), setTimeout(() => {
            t.resetChat();
          }, 200);
          break;
        default:
          D(
            x,
            w.name
          );
      }
  };
  return a && e.hideOnSmallScreen || !a && e.hideOnLargeScreen ? null : ((I = e.confirmation) == null ? void 0 : I.type) === "modal" && !d && !l ? /* @__PURE__ */ r(
    It,
    {
      trigger: /* @__PURE__ */ r(
        C,
        {
          variant: "ghost",
          size: "fit",
          className: "rounded-full",
          disabled: m,
          children: /* @__PURE__ */ r(te, { name: e.icon })
        }
      ),
      children: /* @__PURE__ */ c(kt, { children: [
        /* @__PURE__ */ r(Ct, { children: /* @__PURE__ */ r(St, { children: e.confirmation.title || "Close conversation" }) }),
        /* @__PURE__ */ r(zt, { children: /* @__PURE__ */ r(_t, { children: e.confirmation.description || "Are you sure you want to close this conversation?" }) }),
        /* @__PURE__ */ c(Nt, { children: [
          /* @__PURE__ */ r(
            C,
            {
              variant: "secondary",
              onClick: o,
              disabled: i.isResolvingSession,
              children: e.confirmation.cancelButtonText || "No"
            }
          ),
          /* @__PURE__ */ r(
            C,
            {
              variant: "destructive",
              onClick: z,
              disabled: i.isResolvingSession,
              children: e.confirmation.confirmButtonText || "Yes"
            }
          )
        ] })
      ] })
    }
  ) : /* @__PURE__ */ r(
    C,
    {
      variant: "ghost",
      size: "fit",
      className: "rounded-full",
      onClick: d || l ? w : z,
      disabled: m,
      children: /* @__PURE__ */ r(te, { name: e.icon })
    }
  );
}
function fe({ button: e }) {
  switch (e.functionality) {
    case "close-widget":
      return /* @__PURE__ */ r(Jr, { button: e });
    case "expand-shrink":
      return /* @__PURE__ */ r(ue, { button: e });
    case "resolve-session":
      return /* @__PURE__ */ r(Pt, { button: e });
    default:
      return D(e, fe.name), null;
  }
}
const eo = {
  functionality: "close-widget",
  hideOnLargeScreen: !0,
  icon: "X"
};
function to() {
  const {
    routerState: { screen: e }
  } = A(), { headerButtons: o } = b(), t = e === "chat" ? o == null ? void 0 : o.chatScreen : e === "sessions" ? o == null ? void 0 : o.sessionsScreen : [];
  return !t || t.length === 0 ? /* @__PURE__ */ r(fe, { button: eo }) : /* @__PURE__ */ r(re, { children: t.map((n) => /* @__PURE__ */ r(
    fe,
    {
      button: n
    },
    `${n.functionality}-${n.icon}`
  )) });
}
function At() {
  const {
    routerState: { screen: e }
  } = A(), o = Qr(e), t = Ne();
  return /* @__PURE__ */ c("header", { ...o, className: "py-2 px-4 shrink-0", children: [
    /* @__PURE__ */ c("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ r(Zr, {}),
      /* @__PURE__ */ r(
        "div",
        {
          className: p(
            "flex-1 h-8 flex items-center",
            e === "sessions" && "ps-2"
          ),
          children: /* @__PURE__ */ r(
            Kr,
            {
              fallback: /* @__PURE__ */ r("h2", { className: "font-semibold", children: t })
            }
          )
        }
      ),
      /* @__PURE__ */ r(to, {})
    ] }),
    /* @__PURE__ */ r(Gr, {})
  ] });
}
function Ft({ className: e }) {
  return /* @__PURE__ */ r(wr, { className: p("size-4 animate-spin", e) });
}
function ro() {
  const {
    messagesState: { isInitialFetchLoading: e }
  } = E(), { isSmallScreen: o } = F(), { activeMode: t, Component: n } = mt();
  return {
    isCanvasOpen: !e && !o && !!t && !!n
  };
}
function oo() {
  const e = Z(), { activeMode: o, Component: t } = mt(), { sendMessage: n } = E(), { createStateCheckpoint: s } = $(), [i, a] = T(!1), l = async (d) => {
    try {
      a(!0), await n(d);
    } catch (h) {
      console.error(h);
    } finally {
      a(!1);
    }
  };
  return !o || !t ? null : /* @__PURE__ */ r(
    t,
    {
      ...e,
      mode: o,
      createStateCheckpoint: s,
      sendMessage: l,
      isSendingMessage: i
    }
  );
}
const P = U.forwardRef(
  (e, o) => {
    var t, n, s;
    return /* @__PURE__ */ r(
      u,
      {
        ...e,
        ref: o,
        className: p("overflow-hidden", e.className),
        overrides: {
          initial: { height: 0, opacity: 0, ...(t = e.overrides) == null ? void 0 : t.initial },
          animate: { height: "auto", opacity: 1, ...(n = e.overrides) == null ? void 0 : n.animate },
          exit: { height: 0, opacity: 0, ...(s = e.overrides) == null ? void 0 : s.exit }
        }
      }
    );
  }
);
P.displayName = "MotionDiv__VerticalReveal";
const no = [
  {
    label: "Terrible",
    value: 1,
    emoji: "😡"
  },
  {
    label: "Poor",
    value: 2,
    emoji: "😞"
  },
  {
    label: "Okay",
    value: 3,
    emoji: "😐"
  },
  {
    label: "Good",
    value: 4,
    emoji: "😊"
  },
  {
    label: "Great",
    value: 5,
    emoji: "😍"
  }
];
function so() {
  const { isSmallScreen: e } = F(), {
    submitCsat: o,
    isCsatRequested: t,
    isCsatSubmitted: n,
    submittedScore: s,
    submittedFeedback: i
  } = gt(), [a, l] = T(null), [d, h] = T(null), y = (m) => {
    l((z) => z === m ? null : m);
  }, x = () => {
    a && o({
      score: a,
      feedback: d || void 0
    });
  };
  return !t && !n ? null : /* @__PURE__ */ c("div", { className: "w-1/2 min-w-80 max-w-96 mx-auto overflow-hidden", children: [
    /* @__PURE__ */ r(_, { mode: "wait", children: t && !a ? /* @__PURE__ */ r(P, { children: /* @__PURE__ */ r("p", { className: "text-sm text-muted-foreground text-center pt-2", children: "How was your conversation?" }) }, "csat-requested-title") : n ? /* @__PURE__ */ r(P, { children: /* @__PURE__ */ r("p", { className: "text-sm text-muted-foreground text-center pt-2", children: "You rated the conversation as" }) }, "csat-submitted-title") : null }),
    /* @__PURE__ */ r(
      "div",
      {
        className: p(
          "flex gap-4 justify-between pt-2 px-2 pb-2",
          "transition-all",
          n && "gap-0 justify-center"
        ),
        children: no.map((m) => /* @__PURE__ */ r(
          C,
          {
            variant: m.value === a ? "secondary" : "ghost",
            size: "selfless",
            className: p(
              "transition-all overflow-hidden",
              "text-2xl size-8 rounded-full",
              "opacity-35",
              "hover:opacity-100",
              !a && "opacity-100",
              m.value === a && "opacity-100",
              n && m.value !== s && "opacity-0 size-0",
              n && m.value === s && "opacity-100 size-fit text-4xl"
            ),
            onClick: t ? () => y(m.value) : void 0,
            children: m.emoji
          },
          m.value
        ))
      }
    ),
    /* @__PURE__ */ r(_, { mode: "wait", children: (a || s) && /* @__PURE__ */ r(P, { children: /* @__PURE__ */ c("div", { className: "pb-2 px-2 flex items-end", children: [
      /* @__PURE__ */ r(
        "textarea",
        {
          rows: 3,
          className: p(
            "transition-all",
            "max-h-40 [field-sizing:content]",
            "w-full resize-none",
            "bg-transparent outline-none",
            "placeholder:text-muted-foreground",
            // 16px on mobiles prevents auto-zoom on the input when focused
            e ? "text-[16px]" : "text-sm",
            n && "text-center"
          ),
          value: n ? i || "" : d || "",
          onChange: t ? (m) => h(m.target.value) : void 0,
          readOnly: n,
          placeholder: t ? "Tell us more... (optional)" : void 0
        }
      ),
      /* @__PURE__ */ r(
        C,
        {
          size: "fit",
          onClick: x,
          disabled: !a,
          className: p(
            "transition-all overflow-hidden",
            "rounded-full size-8 flex items-center justify-center p-0",
            n && "opacity-0 size-0"
          ),
          children: /* @__PURE__ */ r(ft, { className: "size-4" })
        }
      )
    ] }) }, "feedback-box") }),
    /* @__PURE__ */ r("div", { className: p("h-0 transition-[height]", n && "h-4") })
  ] });
}
function X() {
  const { dir: e } = ve(), o = b();
  return ht(() => {
    const t = Tr(o.language) ? o.language : "en";
    return {
      t: (n) => Mr(n, t, o.translationOverrides),
      language: t,
      dir: t === "ar" ? "rtl" : "ltr",
      hostDocumentDir: e
    };
  }, [o.language, e]);
}
function Se({
  suggestion: e,
  className: o,
  ...t
}) {
  const { sendMessage: n } = E(), s = () => {
    const i = e.trim();
    i && n({ content: i });
  };
  return /* @__PURE__ */ r(
    C,
    {
      ...g("chat/suggested_reply_btn"),
      size: "sm",
      className: p("rounded-xl w-fit", o),
      ...t,
      onClick: s,
      children: e
    }
  );
}
function ao() {
  const { t: e } = X(), o = [e("i_need_more_help"), e("this_was_helpful")];
  return /* @__PURE__ */ r(
    "div",
    {
      ...g("chat/might_solve_user_issue_suggested_replies_container"),
      className: "flex items-center gap-2 p-2 pb-0 flex-wrap",
      children: o.map((t) => /* @__PURE__ */ r(
        Se,
        {
          suggestion: t,
          className: "flex-1"
        },
        t
      ))
    }
  );
}
function it() {
  const { sessionState: e } = $(), { chatFooterItems: o } = b(), t = !!e.session && !e.session.isOpened, n = !t;
  return /* @__PURE__ */ r(_, { mode: "wait", children: o == null ? void 0 : o.map((s, i) => s.showWhenSessionIsOpen === !1 && n || s.showWhenSessionIsResolved === !1 && t ? null : /* @__PURE__ */ r(P, { children: /* @__PURE__ */ r("div", { className: "pb-2 text-center text-xs", children: /* @__PURE__ */ r(be, { children: s.message }) }) }, `${s.message}-${i}`)) });
}
function io({
  file: { status: e, file: o, error: t },
  onCancel: n
}) {
  const [s, i] = T(
    null
  );
  oe(() => {
    if (!o.type.startsWith("image/")) return;
    const d = new FileReader();
    return d.onload = () => i(d.result), d.onerror = () => console.error("Error reading file"), d.readAsDataURL(o), () => d.abort();
  }, [o]);
  const a = () => {
    switch (e) {
      case "uploading":
        return /* @__PURE__ */ r(br, { className: "size-4 animate-spin" });
      case "error":
        return /* @__PURE__ */ r(xr, { className: "size-4 text-destructive" });
      default:
        return null;
    }
  }, l = () => {
    const d = o.type.split("/")[0];
    return d === "image" && s ? /* @__PURE__ */ r(
      "img",
      {
        src: typeof s == "string" ? s : "",
        className: "object-cover bg-secondary size-full",
        alt: o.name
      }
    ) : d === "audio" ? /* @__PURE__ */ r(yr, {}) : d === "video" ? /* @__PURE__ */ r(kr, {}) : /* @__PURE__ */ r(Cr, {});
  };
  return /* @__PURE__ */ r(
    ee,
    {
      side: "bottom",
      content: e === "error" ? /* @__PURE__ */ c("span", { className: "text-destructive", children: [
        "Failed to upload: ",
        t
      ] }) : o.name,
      children: /* @__PURE__ */ c(
        "div",
        {
          className: p(
            e === "uploading" && "opacity-50",
            "group",
            "size-12 border rounded-2xl overflow-hidden relative",
            "flex items-center justify-center shrink-0"
          ),
          children: [
            /* @__PURE__ */ r("div", { className: "absolute inset-0 flex items-center justify-center", children: a() }),
            /* @__PURE__ */ r(
              "button",
              {
                type: "button",
                className: p(
                  "absolute bg-black/50 inset-0 size-full z-10 opacity-0",
                  "flex items-center justify-center",
                  "opacity-0 group-hover:opacity-100 transition"
                ),
                onClick: n,
                children: /* @__PURE__ */ r(xe, { className: "size-4 text-primary-foreground" })
              }
            ),
            /* @__PURE__ */ r(l, {})
          ]
        }
      )
    }
  );
}
function lo() {
  var R;
  const { isSmallScreen: e } = F(), o = de(null), { sendMessage: t } = E(), { sessionState: n } = $(), { t: s } = X(), [i, a] = T(""), {
    allFiles: l,
    emptyTheFiles: d,
    handleCancelUpload: h,
    appendFiles: y,
    isUploading: x,
    successFiles: m
  } = Ut(), z = !!((R = n.session) != null && R.isHandedOff), { isAwaitingBotReply: w } = wt(), k = (v) => {
    y(v);
  }, I = !i.trim() && m.length === 0, f = async () => {
    if (w || I) return;
    x && console.info("please wait for the file(s) to upload");
    const v = i.trim();
    t({
      content: v,
      attachments: m.flatMap(
        (N) => N.fileUrl ? [
          {
            url: N.fileUrl,
            type: N.file.type,
            name: N.file.name,
            id: N.id,
            size: N.file.size
          }
        ] : []
      )
    }), a(""), d();
  }, {
    getRootProps: M,
    getInputProps: O,
    open: H
  } = Dr({
    onDrop: k,
    noClick: !0,
    onDropRejected() {
      console.error("unsupported file type, or the file is too large");
    },
    maxSize: 5 * 1024 * 1024,
    accept: z ? {
      "text/*": [".txt"],
      "image/*": [".png", ".jpg", ".jpeg", ".gif"],
      "application/pdf": [".pdf"]
    } : {
      "image/png": [".png"],
      "image/jpeg": [".jpg", ".jpeg"],
      "image/gif": [".gif"],
      "image/webp": [".webp"]
    }
  }), W = (v) => {
    const N = v.clipboardData;
    N && N.files.length > 0 && k(Array.from(N.files));
  };
  return /* @__PURE__ */ c(
    "div",
    {
      ...g("chat/input_box/root"),
      className: "p-2 relative space-y-1",
      ...M(),
      children: [
        /* @__PURE__ */ r("input", { ...O() }),
        /* @__PURE__ */ c(
          "div",
          {
            ...g("chat/input_box/inner_root"),
            className: p(
              "transition-all",
              "bg-white",
              // 'border',
              "relative rounded-3xl flex flex-col gap-2 p-2",
              "hover:border-primary focus-within:border-primary"
            ),
            children: [
              /* @__PURE__ */ c(
                "div",
                {
                  ...g("chat/input_box/textarea_and_attachments_container"),
                  className: "flex flex-col gap-2",
                  children: [
                    l.length > 0 && /* @__PURE__ */ r(
                      "div",
                      {
                        ...g("chat/input_box/attachments_container"),
                        className: "flex items-center gap-1",
                        children: /* @__PURE__ */ r(_, { mode: "popLayout", children: l.map((v) => /* @__PURE__ */ r(u, { snapExit: !0, children: /* @__PURE__ */ r(
                          io,
                          {
                            onCancel: () => h(v.id),
                            file: v
                          }
                        ) }, v.id)) })
                      }
                    ),
                    /* @__PURE__ */ r(
                      "textarea",
                      {
                        ...g("chat/input_box/textarea"),
                        onPaste: W,
                        ref: o,
                        id: "chat-input",
                        value: i,
                        rows: 3,
                        className: p(
                          /** Match the border radius of the container */
                          // INPUT_CONTAINER_B_RADIUS,
                          "max-h-16 [field-sizing:content]",
                          "w-full resize-none px-2",
                          l.length === 0 && "pt-1",
                          "bg-transparent outline-none",
                          "placeholder:text-muted-foreground",
                          // 16px on mobiles prevents auto-zoom on the input when focused
                          e ? "text-[16px]" : "text-sm"
                        ),
                        onChange: (v) => a(v.target.value),
                        onKeyDown: async (v) => {
                          v.key === "Enter" && !v.shiftKey && (v.preventDefault(), f());
                        },
                        placeholder: s("write_a_message_placeholder")
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ c("div", { className: "gap-2 flex justify-between", children: [
                /* @__PURE__ */ r(
                  ee,
                  {
                    side: "top",
                    align: "start",
                    content: "attach files, (maximum size 5mb)",
                    children: /* @__PURE__ */ r(
                      C,
                      {
                        onClick: H,
                        size: "fit",
                        variant: "ghost",
                        className: p(
                          "rounded-full size-8 flex items-center justify-center p-0 overflow-hidden"
                        ),
                        children: /* @__PURE__ */ r(_, { mode: "wait", children: z && !w ? /* @__PURE__ */ r(u, { children: /* @__PURE__ */ r(ur, { className: "size-4" }) }, "paper-clip") : /* @__PURE__ */ r(u, { children: /* @__PURE__ */ r(fr, { className: "size-4" }) }, "image-icon") })
                      }
                    )
                  }
                ),
                /* @__PURE__ */ r(ee, { content: "send message", side: "top", align: "end", children: /* @__PURE__ */ r(
                  C,
                  {
                    size: "fit",
                    onClick: f,
                    disabled: w || x || I,
                    className: "rounded-full size-8 flex items-center justify-center p-0",
                    children: /* @__PURE__ */ r(_, { mode: "wait", children: w || x ? /* @__PURE__ */ r(u, { snapExit: !0, children: /* @__PURE__ */ r(vr, { className: "size-4 animate-spin animate-iteration-infinite" }) }, "loading") : /* @__PURE__ */ r(u, { snapExit: !0, children: /* @__PURE__ */ r(ft, { className: "size-4" }) }, "send") })
                  }
                ) })
              ] })
            ]
          }
        )
      ]
    }
  );
}
function lt() {
  const { widgetCtx: e } = j(), { router: o } = b(), { canCreateNewSession: t } = $(), { toSessionsScreen: n } = A(), { t: s } = X();
  return /* @__PURE__ */ r(re, { children: t || o != null && o.chatScreenOnly ? /* @__PURE__ */ r(C, { onClick: e.resetChat, className: "rounded-2xl w-full", children: s("new_conversation") }) : /* @__PURE__ */ r(C, { onClick: n, className: "rounded-2xl w-full", children: s("back_to_conversations") }) });
}
function co() {
  const { t: e } = X(), { isCsatRequested: o, isCsatSubmitted: t } = gt();
  return /* @__PURE__ */ r("div", { className: "p-2", children: /* @__PURE__ */ r("div", { className: "p-2 bg-muted rounded-3xl", children: /* @__PURE__ */ r(_, { mode: "wait", children: o || t ? /* @__PURE__ */ c(P, { children: [
    /* @__PURE__ */ r(so, {}),
    /* @__PURE__ */ r(_, { mode: "wait", children: t && /* @__PURE__ */ r(P, { children: /* @__PURE__ */ r(lt, {}) }, "new-conv-or-back-to-convs-button") })
  ] }, "csat") : /* @__PURE__ */ c(P, { children: [
    /* @__PURE__ */ c("div", { className: "ps-2 flex items-center gap-1 pb-2", children: [
      /* @__PURE__ */ r(ut, { className: "size-4 text-emerald-600" }),
      /* @__PURE__ */ r("h2", { className: "text-sm font-medium", children: e("your_issue_has_been_resolved") })
    ] }),
    /* @__PURE__ */ r(lt, {})
  ] }, "session-closed") }) }) });
}
function po() {
  var a;
  const { initialQuestions: e, initialQuestionsPosition: o, thisWasHelpfulOrNot: t } = b(), { sessionState: n } = $(), { messagesState: s } = E(), i = s.messages.length === 0;
  return /* @__PURE__ */ r("footer", { children: /* @__PURE__ */ r(_, { mode: "wait", children: n.session && !((a = n.session) != null && a.isOpened) ? /* @__PURE__ */ c(P, { children: [
    /* @__PURE__ */ r(co, {}),
    /* @__PURE__ */ r(it, {})
  ] }, "session-closed") : /* @__PURE__ */ c(P, { children: [
    s.lastAIResMightSolveUserIssue && (t == null ? void 0 : t.enabled) !== !1 && /* @__PURE__ */ r(ao, {}),
    i && e && o !== "below-initial-messages" && /* @__PURE__ */ r("div", { className: "flex items-center flex-row justify-end gap-2 flex-wrap px-2", children: e == null ? void 0 : e.map((l, d) => /* @__PURE__ */ r(
      Se,
      {
        suggestion: l
      },
      `${l}-${d}`
    )) }),
    /* @__PURE__ */ r(lo, {}),
    /* @__PURE__ */ r(it, {})
  ] }, "chat-input") }) });
}
function ho({
  isFirstInGroup: e,
  isLastInGroup: o,
  isAloneInGroup: t,
  ...n
}) {
  const { componentStore: s } = j();
  if (n.type !== "AGENT" && n.type !== "AI") return null;
  if (n.data.action) {
    const a = s.getComponent(n.data.action.name);
    if (a)
      return /* @__PURE__ */ r(
        a,
        {
          ...n,
          id: n.id,
          isFirstInGroup: e,
          isLastInGroup: o,
          isAloneInGroup: t
        }
      );
  }
  const i = s.getComponent(n.component);
  return i ? /* @__PURE__ */ r(
    i,
    {
      ...n,
      id: n.id,
      isFirstInGroup: e,
      isLastInGroup: o,
      isAloneInGroup: t
    }
  ) : /* @__PURE__ */ r(
    ge,
    {
      ...n,
      isFirstInGroup: e,
      isLastInGroup: o,
      isAloneInGroup: t
    }
  );
}
function Ot({
  messages: e,
  className: o,
  containerClassName: t
}) {
  var a, l;
  const { timestamps: n } = b();
  if (!((a = n == null ? void 0 : n.perMessageGroup) != null && a.enabled))
    return null;
  const s = (l = e[e.length - 1]) == null ? void 0 : l.timestamp;
  if (!s) return null;
  const i = (() => {
    try {
      return new Date(s).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: !0
      });
    } catch (d) {
      return console.error(d), null;
    }
  })();
  return i ? /* @__PURE__ */ r("div", { className: t, children: /* @__PURE__ */ r("span", { className: p("text-xs text-muted-foreground", o), children: i }) }) : null;
}
function le({
  messages: e,
  agent: o,
  suggestedReplies: t
}) {
  return /* @__PURE__ */ c(
    "div",
    {
      ...g("chat/agent_msg_group/root"),
      className: p("flex items-end gap-2"),
      children: [
        /* @__PURE__ */ r(ee, { content: o == null ? void 0 : o.name, side: "right", align: "end", children: /* @__PURE__ */ r(
          we,
          {
            ...g("chat/agent_msg_group/root/avatar"),
            agent: o,
            className: "hidden"
          }
        ) }),
        /* @__PURE__ */ c("div", { className: p("flex-1 flex flex-col gap-1"), children: [
          /* @__PURE__ */ c(
            "div",
            {
              ...g("chat/agent_msg_group/avatar_and_msgs/root"),
              className: p("flex items-end gap-2"),
              children: [
                /* @__PURE__ */ r(ee, { content: o == null ? void 0 : o.name, side: "right", align: "end", children: /* @__PURE__ */ r(
                  we,
                  {
                    ...g("chat/agent_msg_group/avatar_and_msgs/avatar"),
                    agent: o
                  }
                ) }),
                /* @__PURE__ */ c(
                  "div",
                  {
                    ...g("chat/agent_msg_group/avatar_and_msgs/msgs"),
                    className: p("flex-1 flex flex-col gap-1"),
                    children: [
                      e.map((n, s, i) => /* @__PURE__ */ r(
                        ho,
                        {
                          isFirstInGroup: s === 0,
                          isLastInGroup: s === i.length - 1,
                          isAloneInGroup: i.length === 1,
                          ...n
                        },
                        n.id
                      )),
                      /* @__PURE__ */ r(Ot, { messages: e })
                    ]
                  }
                )
              ]
            }
          ),
          t && t.length > 0 && /* @__PURE__ */ r(
            "div",
            {
              ...g("chat/agent_msg_group/suggestions"),
              className: p("flex flex-col gap-1 ps-8"),
              children: t == null ? void 0 : t.map((n, s) => /* @__PURE__ */ r(
                Se,
                {
                  suggestion: n
                },
                `${n}-${s}`
              ))
            }
          )
        ] })
      ]
    }
  );
}
function mo() {
  var t, n;
  const e = Z();
  if ((t = e.session) != null && t.isOpened || !e.session) return null;
  const o = (n = e.config.customComponents) == null ? void 0 : n.onSessionResolved;
  return o ? /* @__PURE__ */ r(o, { ...e }) : null;
}
function go({
  message: e,
  isFirstInGroup: o,
  isLastInGroup: t,
  isAloneInGroup: n
}) {
  var s;
  return /* @__PURE__ */ c(
    "div",
    {
      ...g("chat/user_msg/root"),
      className: "w-5/6 flex flex-col items-end gap-1",
      children: [
        e.attachments && e.attachments.length > 0 && /* @__PURE__ */ r("div", { className: "w-full flex gap-1 flex-wrap justify-end", children: (s = e.attachments) == null ? void 0 : s.map((i) => /* @__PURE__ */ r(Tt, { attachment: i }, i.id)) }),
        e.content.length > 0 && /* @__PURE__ */ r(
          "div",
          {
            ...g("chat/user_msg/msg"),
            "data-first": o,
            "data-last": t,
            "data-alone": n,
            className: p(
              "transition-all",
              "w-fit py-3 px-4 rounded-3xl text-sm",
              "bg-primary text-primary-foreground",
              "break-words [word-break:break-word]",
              // `[word-break:break-word]` is deprecated but works in the browser, while `break-words` which is `[overflow-wrap: break-word]` does not work
              "whitespace-pre-wrap",
              // We're using the booleans directly here, not the data attributes, to make any external styling more specific than this
              o && !n && "rounded-br-md",
              t && !n && "rounded-tr-md",
              !o && !t && !n && "rounded-r-md"
            ),
            children: e.content
          }
        )
      ]
    }
  );
}
function wo({
  messages: e
}) {
  return /* @__PURE__ */ c(
    "div",
    {
      ...g("chat/user_msg_group/root"),
      className: p("group", "flex flex-col gap-1 justify-end items-end"),
      children: [
        e.map((o, t, n) => /* @__PURE__ */ r(
          go,
          {
            message: o,
            isFirstInGroup: t === 0,
            isLastInGroup: t === n.length - 1,
            isAloneInGroup: n.length === 1
          },
          o.id
        )),
        /* @__PURE__ */ r(Ot, { messages: e, containerClassName: "ms-auto" })
      ]
    }
  );
}
function uo(e) {
  const o = [];
  let t = null;
  return e.forEach((n) => {
    var s, i, a, l, d, h;
    // Start a new group if the type changes
    (((s = t == null ? void 0 : t[0]) == null ? void 0 : s.type) !== n.type || // Start a new group if the agent changes
    ((i = t[0]) == null ? void 0 : i.type) === "AGENT" && n.type === "AGENT" && (((a = n.agent) == null ? void 0 : a.id) !== ((l = t[0].agent) == null ? void 0 : l.id) || ((d = n.agent) == null ? void 0 : d.name) !== ((h = t[0].agent) == null ? void 0 : h.name))) && (t = [], o.push(t)), t.push(n);
  }), o;
}
function fo(e) {
  var o;
  return ((o = e == null ? void 0 : e[0]) == null ? void 0 : o.type) === "USER";
}
function vo(e) {
  var o;
  return ((o = e == null ? void 0 : e[0]) == null ? void 0 : o.type) === "AI";
}
function xo(e) {
  var o;
  return ((o = e == null ? void 0 : e[0]) == null ? void 0 : o.type) === "AGENT";
}
function bo() {
  const {
    messagesState: { messages: e }
  } = E(), {
    advancedInitialMessages: o = [],
    initialQuestionsPosition: t,
    initialQuestions: n,
    bot: s
  } = b();
  return /* @__PURE__ */ r(re, { children: e.length === 0 && o.length > 0 && /* @__PURE__ */ r(
    le,
    {
      messages: o.map(
        ({ message: i }, a) => ({
          component: "bot_message",
          data: { message: i },
          id: `${a}-${i}`,
          type: "AI",
          timestamp: null
        })
      ),
      suggestedReplies: e.length === 0 && t === "below-initial-messages" ? n : void 0,
      agent: s ? { ...s, isAi: !0, id: null } : void 0
    }
  ) });
}
function yo() {
  const {
    messagesState: { messages: e }
  } = E(), { chatBannerItems: o } = b();
  return !(o != null && o.length) || e.length > 0 && o.every((t) => !t.persistent) ? null : /* @__PURE__ */ r("div", { className: "w-full text-center text-xs", children: o.map(
    ({ message: t, persistent: n }, s) => e.length > 0 && !n ? null : /* @__PURE__ */ r("div", { children: /* @__PURE__ */ r(be, { children: t }) }, `${t}-${s}`)
  ) });
}
function ko() {
  const {
    messagesState: { messages: e }
  } = E(), o = b(), {
    advancedInitialMessages: t = [],
    initialQuestions: n,
    initialQuestionsPosition: s
  } = o, i = (() => {
    var a;
    return t.length ? [] : e.length ? [] : (a = o.initialMessages) != null && a.length ? o.initialMessages : ["Hello, how can I help you?"];
  })();
  return /* @__PURE__ */ r(re, { children: e.length === 0 && i.length > 0 && /* @__PURE__ */ r(
    le,
    {
      messages: i.map(
        (a, l) => ({
          component: "bot_message",
          data: { message: a },
          id: `${l}-${a}`,
          type: "AI",
          timestamp: null
        })
      ),
      suggestedReplies: s === "below-initial-messages" ? n : void 0,
      agent: o.bot ? { ...o.bot, isAi: !0, id: null } : void 0
    }
  ) });
}
function Co() {
  var t;
  const e = Z(), o = (t = e.config.customComponents) == null ? void 0 : t.chatBottomComponents;
  return o ? /* @__PURE__ */ r("div", { children: o.map(({ key: n, component: s }) => /* @__PURE__ */ r(s, { ...e }, n)) }) : null;
}
function zo() {
  const {
    messagesState: { messages: e }
  } = E(), { isAwaitingBotReply: o } = wt(), { componentStore: t } = j(), { bot: n, humanAgent: s } = b(), i = ht(
    () => uo(e),
    [e]
  ), a = t.getComponent(
    "loading"
  ), l = de(null);
  function d() {
    setTimeout(() => {
      const h = l.current;
      h && (h.scrollTop = h.scrollHeight);
    }, 0);
  }
  return oe(() => {
    d();
  }, [e]), /* @__PURE__ */ c(
    "div",
    {
      ...g("chat/msgs/root"),
      ref: l,
      className: "max-h-full scroll-smooth relative flex-1 py-2 px-4 flex flex-col gap-2 overflow-auto",
      children: [
        /* @__PURE__ */ r(yo, {}),
        /* @__PURE__ */ r(bo, {}),
        /* @__PURE__ */ r(ko, {}),
        i.map((h, y) => {
          var z, w, k, I;
          const x = (z = h == null ? void 0 : h[0]) == null ? void 0 : z.type, m = (w = h[0]) == null ? void 0 : w.id;
          if (!x || !m) return null;
          if (fo(h))
            return /* @__PURE__ */ r(wo, { messages: h }, m);
          if (vo(h)) {
            const f = y === i.length - 1;
            return o && f ? null : ((k = h[0]) == null || k.agent, /* @__PURE__ */ r(
              le,
              {
                messages: h,
                agent: n ? { ...n, isAi: !0, id: null } : void 0
              },
              m
            ));
          }
          if (xo(h)) {
            const f = (I = h[0]) == null ? void 0 : I.agent;
            return /* @__PURE__ */ r(
              le,
              {
                messages: h,
                agent: f ? {
                  ...f,
                  name: (s == null ? void 0 : s.name) || f.name || "",
                  avatarUrl: (s == null ? void 0 : s.avatarUrl) || f.avatarUrl || null
                } : s ? {
                  isAi: !1,
                  id: null,
                  name: s.name || "",
                  avatarUrl: s.avatarUrl || null
                } : void 0
              },
              m
            );
          }
          return null;
        }),
        o && a && /* @__PURE__ */ r(a, { agent: n }),
        /* @__PURE__ */ r(Co, {}),
        /* @__PURE__ */ r(mo, {})
      ]
    }
  );
}
function No() {
  const {
    messagesState: { isInitialFetchLoading: e }
  } = E(), {
    sessionState: { session: o }
  } = $(), { isCanvasOpen: t } = ro(), { theme: n } = q();
  ze({
    width: t ? n.screens.chat.withCanvas.width : n.screens.chat.width,
    height: t ? n.screens.chat.withCanvas.height : n.screens.chat.height
  });
  const s = de((o == null ? void 0 : o.id) || "chat").current;
  return /* @__PURE__ */ r(
    "div",
    {
      ...g("chat/root"),
      className: p("flex flex-col overflow-hidden"),
      style: {
        width: "100vw",
        // Relative to the iframe
        maxWidth: "100vw",
        // Relative to the iframe
        height: "100vh",
        // Relative to the iframe
        maxHeight: "100vh"
        // Relative to the iframe
      },
      children: /* @__PURE__ */ c("div", { className: "size-full justify-between flex flex-col", children: [
        /* @__PURE__ */ r(At, {}),
        /* @__PURE__ */ r(_, { mode: "wait", children: e ? /* @__PURE__ */ r(
          u,
          {
            className: "flex flex-col items-center justify-center w-full flex-1",
            children: /* @__PURE__ */ r(Ft, {})
          },
          "loading"
        ) : /* @__PURE__ */ c(
          u,
          {
            className: "flex items-start h-full flex-1 overflow-auto",
            snapExit: !0,
            children: [
              /* @__PURE__ */ c(
                "div",
                {
                  ...g("chat/main/root"),
                  className: p(
                    "flex flex-col h-full overflow-auto transition-all",
                    t ? "w-2/5" : "w-full"
                  ),
                  style: {
                    transitionTimingFunction: n.screens.chat.withCanvas.transitionTimingFunction,
                    transitionDuration: n.screens.chat.withCanvas.transitionDuration
                  },
                  children: [
                    /* @__PURE__ */ r(zo, {}),
                    /* @__PURE__ */ r(po, {})
                  ]
                }
              ),
              /* @__PURE__ */ r(
                "div",
                {
                  ...g("chat/canvas/root"),
                  className: p(
                    "h-full overflow-auto transition-all",
                    t ? "w-3/5" : "w-0"
                  ),
                  style: {
                    transitionTimingFunction: n.screens.chat.withCanvas.transitionTimingFunction,
                    transitionDuration: n.screens.chat.withCanvas.transitionDuration
                  },
                  children: /* @__PURE__ */ r(oo, {})
                }
              )
            ]
          },
          s
        ) })
      ] })
    }
  );
}
function So({
  className: e,
  ...o
}) {
  return /* @__PURE__ */ r(
    "div",
    {
      className: p("animate-pulse rounded-md bg-secondary", e),
      ...o
    }
  );
}
function _o({ className: e }) {
  return /* @__PURE__ */ r(
    "svg",
    {
      width: "26",
      height: "32",
      viewBox: "0 0 26 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: p("text-primary-foreground", e),
      children: /* @__PURE__ */ r(
        "path",
        {
          d: "M1.34103 25.6132H5.44245C5.74203 25.6228 6.02673 25.7462 6.23867 25.9582C6.45062 26.1703 6.5739 26.4551 6.58348 26.7548V30.8584C6.59305 31.1581 6.71634 31.443 6.92828 31.655C7.14023 31.8671 7.42492 31.9904 7.7245 32H18.2894C18.589 31.9904 18.8737 31.8671 19.0856 31.655C19.2976 31.443 19.4209 31.1581 19.4304 30.8584V26.7548C19.4401 26.4545 19.5638 26.1692 19.7765 25.957C19.9892 25.7449 20.2748 25.6219 20.5749 25.6132H24.659C24.9586 25.6036 25.2433 25.4803 25.4552 25.2682C25.6671 25.0562 25.7904 24.7713 25.8 24.4716V7.52839C25.7904 7.22865 25.6671 6.94381 25.4552 6.73176C25.2433 6.5197 24.9586 6.39635 24.659 6.38677H20.561C20.2603 6.37802 19.9742 6.25457 19.7614 6.04169C19.5487 5.82881 19.4253 5.54261 19.4165 5.24168V1.14161C19.4072 0.84419 19.2858 0.561291 19.0768 0.349589C18.8678 0.137887 18.5865 0.0130193 18.2894 0L7.7245 0C7.42492 0.00957792 7.14023 0.132929 6.92828 0.344983C6.71634 0.557036 6.59305 0.841878 6.58348 1.14161V5.24168C6.57477 5.54203 6.45187 5.82773 6.23983 6.04052C6.0278 6.25331 5.74262 6.37715 5.44245 6.38677H1.34103C1.04144 6.39635 0.756749 6.5197 0.544805 6.73176C0.332861 6.94381 0.209574 7.22865 0.200001 7.52839V24.4716C0.209574 24.7713 0.332861 25.0562 0.544805 25.2682C0.756749 25.4803 1.04144 25.6036 1.34103 25.6132ZM6.58348 24.4716V7.52839C6.59305 7.22865 6.71634 6.94381 6.92828 6.73176C7.14023 6.5197 7.42492 6.39635 7.7245 6.38677H18.2894C18.589 6.39635 18.8737 6.5197 19.0856 6.73176C19.2976 6.94381 19.4209 7.22865 19.4304 7.52839V24.4716C19.4209 24.7713 19.2976 25.0562 19.0856 25.2682C18.8737 25.4803 18.589 25.6036 18.2894 25.6132H7.7245C7.42492 25.6036 7.14023 25.4803 6.92828 25.2682C6.71634 25.0562 6.59305 24.7713 6.58348 24.4716Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function Ht({ className: e }) {
  const { token: o } = b();
  return /* @__PURE__ */ r(
    "div",
    {
      className: p(
        "flex items-center justify-center gap-2 p-2 pt-0",
        e
      ),
      children: /* @__PURE__ */ r(L, { children: /* @__PURE__ */ c(
        "a",
        {
          href: `https://open.cx/?ref=${o}`,
          target: "_blank",
          rel: "noreferrer",
          className: p(
            "text-[10px] flex items-center",
            "text-muted-foreground/70 [&_svg]:text-muted-foreground/70",
            "hover:text-primary [&_svg]:hover:text-primary"
          ),
          children: [
            /* @__PURE__ */ r("span", { children: "Powered by" }),
            /* @__PURE__ */ r("span", { children: " " }),
            /* @__PURE__ */ c("span", { className: "flex items-center gap-[1px]", children: [
              /* @__PURE__ */ r("span", { children: /* @__PURE__ */ r(_o, { className: "size-3 inline-block" }) }),
              /* @__PURE__ */ r("span", { className: "font-semibold", children: "open" })
            ] })
          ]
        }
      ) })
    }
  );
}
function Io({ children: e }) {
  return /* @__PURE__ */ r("p", { className: "ps-4 text-xs text-muted-foreground/75 uppercase font-semibold tracking-tight", children: e });
}
function ct({
  session: e,
  className: o
}) {
  const { bot: t, humanAgent: n } = b(), { toChatScreen: s } = A(), i = e.assignee.kind === "human" ? (n == null ? void 0 : n.name) || e.assignee.name || "Support Agent" : (t == null ? void 0 : t.name) || "AI Support Agent", a = e.assignee.kind === "human" ? (n == null ? void 0 : n.avatarUrl) || e.assignee.avatarUrl || "" : (t == null ? void 0 : t.avatarUrl) || (t == null ? void 0 : t.avatar) || "";
  return /* @__PURE__ */ c(
    C,
    {
      variant: "ghost",
      size: "lg",
      className: p(
        "rounded-full p-2 pe-4 flex text-start justify-between w-full whitespace-normal",
        o
      ),
      onClick: () => s(e.id),
      children: [
        /* @__PURE__ */ c("div", { className: "flex-1 flex gap-2 items-center", children: [
          /* @__PURE__ */ r(_, { mode: "wait", children: /* @__PURE__ */ r(u, { snapExit: !0, children: /* @__PURE__ */ c(ye, { className: "size-10", children: [
            /* @__PURE__ */ r(ke, { src: a, alt: "Agent Icon" }),
            /* @__PURE__ */ r(Ce, { children: /* @__PURE__ */ r(zr, { className: "size-4" }) })
          ] }) }) }),
          /* @__PURE__ */ c("div", { className: "flex-1", children: [
            /* @__PURE__ */ r(_, { mode: "wait", children: /* @__PURE__ */ r(u, { snapExit: !0, children: i }, i) }),
            /* @__PURE__ */ r(_, { mode: "wait", children: e.lastMessage ? /* @__PURE__ */ r(u, { snapExit: !0, children: /* @__PURE__ */ r(
              Mt,
              {
                remarkPlugins: [vt],
                rehypePlugins: [xt],
                className: "line-clamp-1 overflow-hidden text-ellipsis text-xs text-muted-foreground",
                children: e.lastMessage
              }
            ) }, e.lastMessage || "content") : /* @__PURE__ */ r(u, { className: "w-1/2", snapExit: !0, children: /* @__PURE__ */ r(So, { className: "h-4 w-full" }) }, "skeleton") })
          ] })
        ] }),
        /* @__PURE__ */ r(Nr, { className: "size-4 text-muted-foreground shrink-0 rtl:-scale-100" })
      ]
    }
  );
}
function To() {
  const { t: e } = X(), { toChatScreen: o } = A(), {
    sessionsState: { data: t, isInitialFetchLoading: n },
    openSessions: s,
    closedSessions: i,
    canCreateNewSession: a
  } = $();
  return /* @__PURE__ */ r("div", { className: "flex-1 flex flex-col overflow-scroll py-2 px-2", children: /* @__PURE__ */ r(_, { mode: "wait", children: n ? /* @__PURE__ */ r(
    u,
    {
      className: "flex-1 flex items-center justify-center",
      children: /* @__PURE__ */ r(Ft, {})
    },
    "loading"
  ) : /* @__PURE__ */ r(
    u,
    {
      className: "flex-1 flex flex-col gap-2 relative",
      children: t.length ? /* @__PURE__ */ c(re, { children: [
        /* @__PURE__ */ c(_, { children: [
          s.length > 0 && /* @__PURE__ */ r(
            u,
            {
              fadeIn: "up",
              delay: 0.2,
              className: "space-y-2",
              snapExit: !0,
              children: s.map((l) => /* @__PURE__ */ r(ct, { session: l }, l.id))
            },
            "open-sessions"
          ),
          i.length > 0 && /* @__PURE__ */ c(
            u,
            {
              className: "space-y-2",
              delay: 0.2,
              snapExit: !0,
              children: [
                /* @__PURE__ */ r(Io, { children: e("closed_conversations") }),
                i.map((l) => /* @__PURE__ */ r(
                  ct,
                  {
                    session: l,
                    className: "opacity-50 hover:opacity-100"
                  },
                  l.id
                ))
              ]
            },
            "closed-sessions"
          )
        ] }),
        a && /* @__PURE__ */ r("div", { className: "mt-auto w-full rounded-3xl sticky bottom-0 outline outline-8 outline-background bg-background", children: /* @__PURE__ */ ot(
          C,
          {
            ...g("sessions/new_conversation_btn"),
            size: "lg",
            key: "new-session",
            className: "w-full",
            onClick: () => o()
          },
          e("new_conversation")
        ) })
      ] }) : /* @__PURE__ */ c("div", { className: "flex-1 flex flex-col gap-2 items-center", children: [
        /* @__PURE__ */ r("div", { className: "flex-1 flex items-center justify-center", children: /* @__PURE__ */ r("p", { className: "text-muted-foreground", children: e("no_conversations_yet") }) }),
        /* @__PURE__ */ ot(
          C,
          {
            ...g("sessions/new_conversation_btn"),
            size: "lg",
            key: "new-session",
            className: "w-full",
            onClick: () => o()
          },
          e("new_conversation")
        )
      ] })
    },
    "sessions"
  ) }) });
}
function Mo() {
  const { theme: e } = q();
  return ze({
    width: e.screens.sessions.width,
    height: e.screens.sessions.height
  }), /* @__PURE__ */ r(
    "div",
    {
      ...g("sessions/root"),
      className: p("flex flex-col overflow-hidden bg-background"),
      style: {
        width: "100vw",
        // Relative to the iframe
        maxWidth: "100vw",
        // Relative to the iframe
        height: "100vh",
        // Relative to the iframe
        maxHeight: "100vh"
        // Relative to the iframe
      },
      children: /* @__PURE__ */ c("div", { className: "size-full flex flex-col", children: [
        /* @__PURE__ */ r(At, {}),
        /* @__PURE__ */ r(To, {}),
        /* @__PURE__ */ r(Ht, {})
      ] })
    }
  );
}
const ie = G.forwardRef(
  ({ className: e, type: o, ...t }, n) => {
    const { isSmallScreen: s } = F();
    return /* @__PURE__ */ r(L, { ref: n, children: /* @__PURE__ */ r(
      "input",
      {
        type: o,
        className: p(
          // 16px on mobiles prevents auto-zoom on the input when focused
          s ? "text-[16px]" : "text-sm",
          "flex w-full rounded-xl p-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-primary-foreground placeholder:text-muted-foreground/75 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 transition",
          "rounded-2xl px-4",
          "border shadow-sm",
          e
        ),
        ...t
      }
    ) });
  }
);
ie.displayName = "Input";
function Do() {
  const { contentIframeRef: e } = j(), { inline: o } = b(), t = de(null);
  return oe(() => {
    const n = e == null ? void 0 : e.current;
    if (n && t.current) {
      const s = t.current;
      let i;
      const a = new ResizeObserver(() => {
        i = requestAnimationFrame(() => {
          const l = s.offsetHeight;
          n.style.setProperty(
            "--opencx-widget-height",
            o ? "100%" : `${l.toFixed(1)}px`
          );
        });
      });
      return a.observe(s), () => {
        cancelAnimationFrame(i), a.unobserve(s);
      };
    }
  }, [e, o]), { observedElementRef: t };
}
const jo = me.object({
  name: me.string().min(2),
  email: me.string().email()
});
function Eo() {
  var f, M, O, H, W, R, v, N;
  const {
    widgetCtx: { org: e }
  } = j(), { setIsOpen: o } = K(), { createUnverifiedContact: t } = qt(), { isSmallScreen: n } = F(), s = b(), { theme: i } = q(), { t: a } = X(), { observedElementRef: l } = Do();
  ze({
    height: void 0,
    width: i.screens.welcome.width
  });
  const [d, h] = T(((f = s.prefillUserData) == null ? void 0 : f.name) || ""), [y, x] = T(((M = s.prefillUserData) == null ? void 0 : M.email) || ""), m = (s.extraDataCollectionFields || []).filter(
    (S) => S !== "name" && S !== "email" && !!S
  ), [z, w] = T({}), [k, I] = jr(
    async (S) => {
      S.preventDefault();
      const B = jo.safeParse({ name: d, email: y });
      B.success && await t(
        {
          email: B.data.email,
          non_verified_name: B.data.name
        },
        // Only pass extra data if there is any
        Object.values(z).filter(Boolean).length ? z : void 0
      );
    },
    [d, y, z]
  );
  return /* @__PURE__ */ r(
    "div",
    {
      style: {
        width: "100vw",
        // Relative to the iframe
        maxWidth: "100vw",
        // Relative to the iframe
        minHeight: i.screens.welcome.minHeight,
        height: "100vh",
        // Relative to the iframe
        maxHeight: "100vh",
        // Relative to the iframe
        overflowY: "auto"
      },
      children: /* @__PURE__ */ c(
        "div",
        {
          ref: l,
          className: p(
            "flex flex-col",
            n && "h-full",
            "bg-[radial-gradient(ellipse_at_top_left,hsl(var(--opencx-primary)),transparent),radial-gradient(ellipse_at_top_right,hsl(var(--opencx-primary)),transparent)]"
          ),
          children: [
            /* @__PURE__ */ c(
              "div",
              {
                className: p(
                  "flex-1 flex flex-col px-4 py-12 text-start space-y-4 relative z-10",
                  "text-primary-foreground"
                ),
                children: [
                  n && /* @__PURE__ */ r(u, { className: "absolute top-6 end-6", children: /* @__PURE__ */ r(C, { size: "selfless", onClick: () => o(!1), children: /* @__PURE__ */ r(xe, { className: "size-4" }) }) }),
                  /* @__PURE__ */ r("div", { className: "flex items-center justify-between w-full mb-2", children: (O = s.assets) != null && O.organizationLogo ? /* @__PURE__ */ r(
                    "img",
                    {
                      src: (H = s.assets) == null ? void 0 : H.organizationLogo,
                      alt: "Company Logo",
                      className: "h-8 w-auto object-contain"
                    }
                  ) : /* @__PURE__ */ r("h2", { className: "font-bold text-sm", children: e.name }) }),
                  /* @__PURE__ */ c("div", { className: "space-y-2", children: [
                    /* @__PURE__ */ r("h1", { className: "text-[1.75rem] font-semibold tracking-tight leading-none", children: ((R = (W = s.textContent) == null ? void 0 : W.welcomeScreen) == null ? void 0 : R.title) || a("welcome_screen_title") }),
                    /* @__PURE__ */ r("p", { className: "text-sm", children: ((N = (v = s.textContent) == null ? void 0 : v.welcomeScreen) == null ? void 0 : N.description) || a("welcome_screen_description") })
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ c(
              "div",
              {
                className: p(
                  "z-10 m-2 px-2 pt-2 bp-0 space-y-2",
                  "bg-[white]",
                  "border shadow",
                  "rounded-3xl"
                ),
                children: [
                  /* @__PURE__ */ c("form", { onSubmit: I, className: "space-y-2", children: [
                    /* @__PURE__ */ r(
                      ie,
                      {
                        value: d,
                        onChange: (S) => h(S.target.value),
                        required: !0,
                        placeholder: a("your_name_placeholder"),
                        name: "name"
                      }
                    ),
                    /* @__PURE__ */ r(
                      ie,
                      {
                        required: !0,
                        value: y,
                        onChange: (S) => x(S.target.value),
                        type: "email",
                        placeholder: a("your_email_placeholder"),
                        name: "email"
                      }
                    ),
                    m.map((S) => /* @__PURE__ */ r(
                      ie,
                      {
                        value: z[S],
                        onChange: (B) => w((se) => ({
                          ...se,
                          [S]: B.target.value
                        })),
                        placeholder: `${S} (${a("optional")})`
                      },
                      S
                    )),
                    /* @__PURE__ */ c(
                      C,
                      {
                        disabled: k.loading,
                        className: "w-full",
                        size: "lg",
                        children: [
                          k.loading ? a("start_chat_button_loading") : a("start_chat_button"),
                          /* @__PURE__ */ r(Sr, { className: "size-4 rtl:-scale-100" })
                        ]
                      }
                    )
                  ] }),
                  /* @__PURE__ */ r(Ht, {})
                ]
              }
            )
          ]
        }
      )
    }
  );
}
function Wt() {
  const {
    routerState: { screen: e }
  } = A();
  return /* @__PURE__ */ r("div", { className: "relative bg-background size-full", children: /* @__PURE__ */ r(_, { mode: "wait", children: (() => {
    switch (e) {
      case "welcome":
        return /* @__PURE__ */ r(
          u,
          {
            fadeIn: "right",
            className: "size-full",
            snapExit: !0,
            children: /* @__PURE__ */ r(Eo, {})
          },
          e
        );
      case "sessions":
        return /* @__PURE__ */ r(
          u,
          {
            fadeIn: "right",
            className: "size-full",
            snapExit: !0,
            children: /* @__PURE__ */ r(Mo, {})
          },
          e
        );
      case "chat":
        return /* @__PURE__ */ r(
          u,
          {
            fadeIn: "right",
            className: "size-full",
            snapExit: !0,
            children: /* @__PURE__ */ r(No, {})
          },
          e
        );
      default:
        return D(e, Wt.name), null;
    }
  })() }) });
}
const Ro = "4.0.42", Po = `<!DOCTYPE html>
<html>
<head>
<style>
${Dt}
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    font-size: 16px;
}
</style>
<meta name="viewport" content="width=device-width, initial-scale=1, interactive-widget=resizes-content">
</head>
<body>
</body>
</html>`;
function Lt() {
  const { isOpen: e } = K(), { contentIframeRef: o } = j(), { cssOverrides: t, inline: n } = b(), { theme: s, cssVars: i, computed: a } = q(), { dir: l } = X();
  return /* @__PURE__ */ r(
    J.div,
    {
      animate: e ? "visible" : "hidden",
      initial: "hidden",
      variants: {
        hidden: {
          opacity: 0,
          y: 8,
          transitionEnd: { display: "none" },
          transition: { duration: 0.15 }
        },
        visible: {
          opacity: 1,
          y: 0,
          display: "block",
          height: n ? "100%" : void 0
        }
      },
      children: /* @__PURE__ */ c(
        bt,
        {
          ref: o,
          initialContent: Po,
          allowFullScreen: !0,
          title: "OpenCX Live Chat",
          style: {
            // @ts-expect-error this is a valid css variable
            "--opencx-widget-width": a.minWidth,
            "--opencx-widget-height": a.minHeight,
            minWidth: a.minWidth,
            width: "var(--opencx-widget-width)",
            maxWidth: a.maxWidth,
            // Relative to the viewport
            minHeight: a.minHeight,
            height: "var(--opencx-widget-height)",
            maxHeight: a.maxHeight,
            // Relative to the viewport
            overflow: "hidden",
            /** outline is better than border because of box sizing; the outline wouldn't affect the content inside... the border will mess up how the children's border radius sits with the parent */
            outline: s.widgetContentContainer.outline,
            outlineColor: s.widgetContentContainer.outlineColor,
            borderRadius: s.widgetContentContainer.borderRadius,
            boxShadow: s.widgetContentContainer.boxShadow,
            transitionProperty: s.widgetContentContainer.transitionProperty,
            transitionTimingFunction: s.widgetContentContainer.transitionTimingFunction,
            transitionDuration: s.widgetContentContainer.transitionDuration,
            // reset iframe defaults
            boxSizing: "border-box",
            borderWidth: "0px"
          },
          children: [
            t && /* @__PURE__ */ r("style", { children: t }),
            /* @__PURE__ */ r(
              "div",
              {
                style: {
                  ...i,
                  zIndex: s.widgetContentContainer.zIndex
                },
                "data-version": Ro,
                className: p(
                  "antialiased font-sans size-full overflow-hidden relative text-secondary-foreground isolate"
                ),
                dir: l,
                children: /* @__PURE__ */ r(
                  Ur,
                  {
                    delayDuration: 200,
                    disableHoverableContent: !0,
                    children: /* @__PURE__ */ r(Wr, { children: /* @__PURE__ */ r(Wt, {}) })
                  }
                )
              }
            )
          ]
        }
      )
    }
  );
}
function Ao() {
  const { theme: e } = q();
  return /* @__PURE__ */ r(
    ce.Content,
    {
      onInteractOutside: (o) => o.preventDefault(),
      forceMount: !0,
      style: {
        zIndex: e.widgetContentContainer.zIndex,
        fontSize: "16px"
      },
      side: "top",
      align: "end",
      "aria-modal": "false",
      "aria-label": "Support chat",
      sideOffset: e.widgetContentContainer.offset.side,
      alignOffset: e.widgetContentContainer.offset.align,
      avoidCollisions: !1,
      children: /* @__PURE__ */ r(Lt, {})
    }
  );
}
function Fo({
  className: e,
  style: o
}) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "32",
      height: "30",
      viewBox: "0 0 32 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: p("text-primary-foreground", e),
      style: o,
      children: [
        /* @__PURE__ */ r(
          "path",
          {
            d: "M0 6.94263C0 3.62892 2.68629 0.942627 6 0.942627H26C29.3137 0.942627 32 3.62892 32 6.94263V17.9426C32 21.2563 29.3137 23.9426 26 23.9426H6C2.68629 23.9426 0 21.2563 0 17.9426V6.94263Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.9945 23.8935L26.237 23.8934C26.1982 24.3557 26.1712 25.2778 26.1704 26.2318C26.1688 28.2839 26.1376 28.7041 25.974 28.868C25.583 29.2598 25.2686 29.0967 24.0616 27.8754C23.4162 27.2222 22.1141 25.9522 21.1682 25.0531L19.9945 23.8935Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
const Oo = `<!DOCTYPE html>
<html>
<head>
<style>
${Dt}
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    font-size: 16px;
}
</style>
</head>
<body>
</body>
</html>`;
function Ho() {
  var i, a;
  const { isOpen: e } = K(), { cssOverrides: o, assets: t } = b(), { theme: n, cssVars: s } = q();
  return /* @__PURE__ */ c(
    bt,
    {
      initialContent: Oo,
      title: "OpenCX Live Chat Trigger",
      style: {
        height: `calc(${n.widgetTrigger.size.button}px + ${V.x * 2}px)`,
        width: `calc(${n.widgetTrigger.size.button}px + ${V.y * 2}px)`,
        fontSize: "16px",
        position: "fixed",
        zIndex: n.widgetTrigger.zIndex,
        right: n.widgetTrigger.offset.right,
        bottom: n.widgetTrigger.offset.bottom,
        left: n.widgetTrigger.offset.left,
        // reset iframe defaults
        boxSizing: "border-box",
        borderWidth: "0px",
        // A quick fix for the white square background of the iframe when the hosting website switches to dark mode
        borderRadius: "100%"
      },
      children: [
        o && /* @__PURE__ */ r("style", { children: o }),
        /* @__PURE__ */ r(
          "div",
          {
            style: {
              ...s,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ r(
              ce.PopoverTrigger,
              {
                className: p(
                  "font-sans flex items-center justify-center rounded-full"
                ),
                style: {
                  height: n.widgetTrigger.size.button,
                  width: n.widgetTrigger.size.button
                },
                children: /* @__PURE__ */ r(L, { children: /* @__PURE__ */ r(
                  "div",
                  {
                    ...g("trigger/btn"),
                    className: p(
                      "relative size-full rounded-full",
                      "flex items-center justify-center",
                      "overflow-hidden",
                      "transition-all",
                      "bg-primary",
                      "text-primary-foreground"
                    ),
                    children: /* @__PURE__ */ r(_, { mode: "wait", children: e ? /* @__PURE__ */ r(
                      u,
                      {
                        snapExit: !0,
                        fadeIn: "up",
                        overrides: {
                          initial: { rotate: 45 },
                          animate: { rotate: 0 }
                        },
                        children: (i = t == null ? void 0 : t.widgetTrigger) != null && i.closeIcon ? /* @__PURE__ */ r(
                          "img",
                          {
                            src: t.widgetTrigger.closeIcon,
                            alt: "Widget trigger close icon",
                            style: {
                              width: n.widgetTrigger.size.icon,
                              height: n.widgetTrigger.size.icon
                            }
                          }
                        ) : /* @__PURE__ */ r(
                          _r,
                          {
                            style: {
                              width: n.widgetTrigger.size.icon,
                              height: n.widgetTrigger.size.icon
                            }
                          }
                        )
                      },
                      "x-icon"
                    ) : /* @__PURE__ */ r(
                      u,
                      {
                        snapExit: !0,
                        overrides: {
                          initial: { rotate: 45 },
                          animate: { rotate: 0 }
                        },
                        children: (a = t == null ? void 0 : t.widgetTrigger) != null && a.openIcon ? /* @__PURE__ */ r(
                          "img",
                          {
                            src: t.widgetTrigger.openIcon,
                            alt: "Widget trigger open icon",
                            style: {
                              width: n.widgetTrigger.size.icon,
                              height: n.widgetTrigger.size.icon
                            }
                          }
                        ) : /* @__PURE__ */ r(
                          Fo,
                          {
                            style: {
                              width: n.widgetTrigger.size.icon,
                              height: n.widgetTrigger.size.icon
                            },
                            className: "mt-0.5 opacity-95"
                          }
                        )
                      },
                      "message-icon"
                    ) })
                  }
                ) })
              }
            )
          }
        )
      ]
    }
  );
}
function Wo() {
  const { dir: e } = ve();
  return /* @__PURE__ */ r(
    ce.Anchor,
    {
      style: {
        position: "fixed",
        bottom: 0,
        right: e === "ltr" ? 0 : void 0,
        left: e === "rtl" ? 0 : void 0
      }
    }
  );
}
function Lo() {
  const { isOpen: e, setIsOpen: o } = K();
  return /* @__PURE__ */ c(ce.Root, { open: e, onOpenChange: o, children: [
    /* @__PURE__ */ r(Wo, {}),
    /* @__PURE__ */ r(Ho, {}),
    /* @__PURE__ */ r(Ao, {})
  ] });
}
const $o = [
  {
    key: "loading",
    component: Yr
  },
  {
    key: "fallback",
    component: Br
  },
  {
    key: "bot_message",
    component: ge
  },
  {
    key: "agent_message",
    component: ge
  }
], Bo = {
  get: async (e) => localStorage.getItem(e),
  set: async (e, o) => {
    localStorage.setItem(e, o);
  },
  remove: async (e) => {
    localStorage.removeItem(e);
  }
};
function cn({
  options: e,
  components: o = [],
  loadingComponent: t
}) {
  return /* @__PURE__ */ r(
    Xt,
    {
      components: [...$o, ...o],
      options: e,
      storage: Bo,
      loadingComponent: t,
      children: /* @__PURE__ */ r(Vt, { children: e.inline ? /* @__PURE__ */ r(Lt, {}) : /* @__PURE__ */ r(Lo, {}) })
    }
  );
}
export {
  cn as Widget
};
//# sourceMappingURL=index.js.map
